import React, { FC, useEffect, useState, useContext, useCallback } from 'react';
import axios from 'src/utils/axiosintercpt';
import logo from 'src/assets/mohanbabulandingpage/MBUlogo.png';
import { pConfig } from 'src/config';
import Modal from 'react-bootstrap/Modal';
import Helmet from 'react-helmet';
import Container from 'react-bootstrap/Container';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import ManagementCourseBG from 'src/assets/mohanbabulandingpage/MBUmainbanner.png';
import stream1 from 'src/assets/mohanbabulandingpage/biotech.png';
import acc1 from 'src/assets/mohanbabulandingpage/Accreditation-1.png';
import acc2 from 'src/assets/mohanbabulandingpage/Accreditation-2.png';
import acc3 from 'src/assets/mohanbabulandingpage/Accreditation-3.png';
import acc4 from 'src/assets/mohanbabulandingpage/Accreditation-4.png';
import acc5 from 'src/assets/mohanbabulandingpage/Accreditation-5.png';
import acc6 from 'src/assets/mohanbabulandingpage/Accreditation-6.png';
import GlobalPopupEnquiry from 'src/components/GlobalPopupEnquiry';
import AllianceuniEnquiryForm from 'src/components/AllianceuniEnquiryForm/GlobalPopupEnquiry';
import placement1 from 'src/assets/mohanbabulandingpage/placement1.png';
import placement2 from 'src/assets/mohanbabulandingpage/placement2.png';
import GetAppIcon from '@material-ui/icons/GetApp';
import inf1 from 'src/assets/mohanbabulandingpage/Entrance.png';
import inf2 from 'src/assets/mohanbabulandingpage/AcademicBlocks.png';
import inf3 from 'src/assets/mohanbabulandingpage/Laboratories.png';
import inf4 from 'src/assets/mohanbabulandingpage/Playgrounds.png';
import inf5 from 'src/assets/mohanbabulandingpage/CentralLibrary.png';
import inf6 from 'src/assets/mohanbabulandingpage/Extracurriculars.png';

import Logo1 from 'src/assets/mohanbabulandingpage/Logo-01.jpg';
import Logo2 from 'src/assets/mohanbabulandingpage/Logo-02.jpg';
import Logo3 from 'src/assets/mohanbabulandingpage/Logo-03.jpg';
import Logo4 from 'src/assets/mohanbabulandingpage/Logo-04.jpg';
import Logo5 from 'src/assets/mohanbabulandingpage/Logo-05.jpg';
import Logo6 from 'src/assets/mohanbabulandingpage/Logo-06.jpg';
import Logo7 from 'src/assets/mohanbabulandingpage/Logo-07.jpg';
import Logo8 from 'src/assets/mohanbabulandingpage/Logo-08.jpg';
import Logo9 from 'src/assets/mohanbabulandingpage/Logo-09.jpg';
import Logo10 from 'src/assets/mohanbabulandingpage/Logo-10.jpg';
import Logo11 from 'src/assets/mohanbabulandingpage/Logo-11.jpg';
import Logo12 from 'src/assets/mohanbabulandingpage/Logo-12.jpg';
import Logo13 from 'src/assets/mohanbabulandingpage/Logo-13.jpg';
import Logo14 from 'src/assets/mohanbabulandingpage/Logo-14.jpg';
import Logo15 from 'src/assets/mohanbabulandingpage/Logo-15.jpg';
import whtsp from 'src/assets/Alliancecollege/whatsapp.gif';
import Engineering from 'src/assets/mohanbabulandingpage/Engineering.png';
import Commerce from 'src/assets/mohanbabulandingpage/Commerce.png';
import Management from 'src/assets/mohanbabulandingpage/Management.png';
import Paramedical from 'src/assets/mohanbabulandingpage/Paramedical Sciences.png';
import Banking from 'src/assets/mohanbabulandingpage/Banking & Finance.png';
import computer from 'src/assets/mohanbabulandingpage/Computer-Applications.webp';
import Nursing from 'src/assets/mohanbabulandingpage/Nursing.webp';
import Physiotherapy from 'src/assets/mohanbabulandingpage/Physiotherapy.webp';
import Pharmacy from 'src/assets/mohanbabulandingpage/Pharmacy.webp';

import Agriculture from 'src/assets/mohanbabulandingpage/Agriculture.png';
import Biotechnology from 'src/assets/mohanbabulandingpage/Biotechnology.png';
import VisualCommunication from 'src/assets/mohanbabulandingpage/Visual Communication.png';
import Food from 'src/assets/mohanbabulandingpage/Food Science & Technology.png';
import Animation from 'src/assets/mohanbabulandingpage/Animation & VFX.png';
import Filmmaking from 'src/assets/mohanbabulandingpage/Filmmaking.png';
import Performing from 'src/assets/mohanbabulandingpage/Performing Arts.png';

import EnquiryForm from './Enquiryform';



import whychhose1 from 'src/assets/mohanbabulandingpage/Why Choose 1.png';
import whychhose2 from 'src/assets/mohanbabulandingpage/Why Choose 2.png';
import whychhose3 from 'src/assets/mohanbabulandingpage/Why Choose 3.png';
import whychhose4 from 'src/assets/mohanbabulandingpage/Why Choose 4.png';
import whychhose5 from 'src/assets/mohanbabulandingpage/Why Choose 5.png';
import whychhose6 from 'src/assets/mohanbabulandingpage/Why Choose 6.png';

import banner from 'src/assets/mohanbabulandingpage/MBUBanner3.png';

import Skill from 'src/assets/mohanbabulandingpage/skilldevelopment.png';
import value from 'src/assets/mohanbabulandingpage/value.jpg';
import experimental from 'src/assets/mohanbabulandingpage/experimental.jpg';
import Research from 'src/assets/mohanbabulandingpage/rnd1.jpg';


import Video from 'src/assets/mohanbabulandingpage/Mohan babu University.gif';
import Card from 'react-bootstrap/Card';
import "./styles.css";
import 'animate.css';
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import { useHistory } from 'react-router-dom';
import { useSnackbar } from 'notistack';
import {Hidden
} from '@material-ui/core';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

const Mohanbabu: FC = () => {
  const history = useHistory();
  const { enqueueSnackbar } = useSnackbar();

  const [values, setValues] = useState({
    name: '', email: '', contact: '', course_in_mind: '', location: '', description: ''
  });
  const set = name => {
    return ({ target: { value } }) => {
      setValues(oldValues => ({ ...oldValues, [name]: value }));
    }
  };

  const onSubmit = async (event: { preventDefault: () => void; }) => {
    event.preventDefault();
    const formData = new FormData();
    formData.append('name', values.name);
    formData.append('email', values.email);
    formData.append('contact', values.contact);
    formData.append('course_in_mind', values.course_in_mind);
    formData.append('location', values.location);
    formData.append('description', values.description);
    formData.append('current_url', window.location.href);

    try {
      const response = await axios.post('api/website/home/landingpageenquiry', formData);
      // console.log('response: ', response);


      if (response.data.status) {

        history.push('/thank-you');
      }
    } catch (err) {
      console.error(err);

      enqueueSnackbar('Please try again', {
        variant: 'error',
      });
    }


  }

  const [show, setShow] = useState(false);
  const [text, settext] = useState("Fill-in the Details to Get Started with Your Application Process");

  const handleClose = () => setShow(false);
  const handleShow = ((e: any) => {

    console.log(e);
    console.log(e.target);
    console.log(e.target.value);
    // console.log(text);
    if (e.target.value && e.target.value == "brochure") {
      // console.log(text);
      settext("Fill-in the Details to Access the Brochure.");
      // console.log(text);
    } else {
      settext("Fill-in the Details to Get Started with Your Application Process.");
    }
    setShow(true)
  }
  );
  const owlOptions = {
    margin: 10, nav: true, autoplay: true, autoplayTimeout: 2000,
    responsiveClass: true,
    responsive: {
      0: { items: 1, dots: false, nav: false, loop: true },
      400: { items: 1, dots: false, nav: false, loop: true },
      600: { items: 1, dots: false, nav: true },
      700: { items: 2, dots: false, nav: true },
      1000: {
        items: 4,
        nav: false,
        loop: true
      },
      1440: {
        items: 5,
        nav: false,
        loop: true
      }
    },
  };

  const navigate = (e, id) => {
    e && e.preventDefault(); // to avoid the link from redirecting
    const elementToView = document.getElementById(id);
    elementToView.scrollIntoView();



    const navbarCollapse = document.getElementsByClassName("nav-cutom-yene");
    const ttttElement = navbarCollapse[0];
    ttttElement.classList.remove("show");


  }

  return (


    <>
      <Helmet>
        <title>Mohan Babu University, Tirupati</title>
        <meta name="description"
          content="Get to know all about Mohan Babu University: Courses Offered, Campus, Infrastructure and Facilities, Placements, Admissions, and much more. Apply Now!" />
        <link rel="canonical" href="https://bangalorestudy.com/mohan-babu-university-tirupati" />
        <meta
          name="viewport"
          content="width=device-width; initial-scale=1.0; maximum-scale=1.0; user-scalable=0;"
        />
        <link rel="stylesheet" href="preprod/nursing_admission/assets/css/dental.css" />
        <link rel="stylesheet" href="preprod/nursing_admission/assets/css/style.min.css" />
        <link rel="stylesheet" href="preprod/nursing_admission/assets/css/resp.min.css" />
        <link
          href="https://stackpath.bootstrapcdn.com/font-awesome/4.7.0/css/font-awesome.min.css"
          rel="stylesheet"
          integrity="sha384-wvfXpqpZZVQGK6TAh5PVlGOfQNHSoD2xbE+QkPxCAFlNEevoEH3Sl0sibVcOQVnN"
          crossOrigin="anonymous"
        />
        <script>
          {`
        window.dataLayer = window.dataLayer || [];
        function gtag() {dataLayer.push(arguments); }
        gtag('js', new Date());
        gtag('config', 'AW-990332405');
        `}
        </script>


        <script>{`
      (function (w, d, s, l, i) {
        w[l] = w[l] || []; w[l].push({
          'gtm.start':
        new Date().getTime(), event: 'gtm.js'
			}); var f = d.getElementsByTagName(s)[0],
        j = d.createElement(s), dl = l != 'dataLayer' ? '&l=' + l : ''; j.async = true; j.src =
        'https://www.googletagmanager.com/gtm.js?id=' + i + dl; f.parentNode.insertBefore(j, f);
		})(window, document, 'script', 'dataLayer', 'GTM-MGDJ5RD');
    `}</script>

        <script async src="https://www.googletagmanager.com/gtag/js?id=AW-990332405"></script>
        <script src="preprod/medical_admission_asset/js/jquery.min.js"></script>
        <script async src="https://www.googletagmanager.com/gtag/js?id=UA-140595938-1"></script>





        <script src="https://ajax.googleapis.com/ajax/libs/jquery/3.5.1/jquery.min.js"></script>

        <script src="https://cdnjs.cloudflare.com/ajax/libs/popper.js/1.16.0/umd/popper.min.js"></script>

        {/* <script src="https://maxcdn.bootstrapcdn.com/bootstrap/4.5.2/js/bootstrap.min.js"></script> */}

        <script src="https://cdnjs.cloudflare.com/ajax/libs/jquery/2.1.3/jquery.min.js"></script>
        <script src="https://cdn.jsdelivr.net/jquery.slick/1.4.1/slick.min.js"></script>

        <script src="preprod/medical_admission_asset/js/jquery.min.js"></script>
        <script src="preprod/nursing_admission/assets/js/jquery.min.js"></script>
        <script type="text/javascript" src="preprod/nursing_admission/assets/js/jquery.fancybox.pack.js"></script>
        <script src="preprod/nursing_admission/assets/js/owl.carousel.min.js"></script>

        <script type="text/javascript"
          src="https://bangalorestudy.com/veterinary_assets/asset/js/owl.carousel.min.js "></script>


        <script type="text/javascript">{`
      

setTimeout(function () {
  $('.widget-visible').remove();
}, 15000);
setTimeout(function () {
  $('.widget-visible').remove();
}, 10000);

setTimeout(function () {
  $('.widget-visible').remove();
}, 5000);

setTimeout(function () {
  $('.widget-visible').remove();
}, 3000);

setTimeout(function () {
  $('.widget-visible').remove();
}, 2000);


setTimeout(function () {
  $('.widget-visible').remove();
}, 1000);
$(document).ready(function () {
  $("#formoid").submit(function (event) {
    console.log("12");
    /* stop form from submitting normally */
    event.preventDefault();

    /* get the action attribute from the <form action=""> element */
    var $form = $(this),
      url = $form.attr('action');

    /* Send the data using post with element id name and name2*/

    var posting = $.post(url, {
      name: $('#name').val(),
      email: $('#email').val(),
      contact: $('#contact').val(),
      college_name: $('#college_name').val(),
      current_url: window.location.href,
      course_in_mind: $('#course_name').val(),
      location: $('#location').val(),
      description: $('#description').val(),

    });

    // console.log($('#name').val(),$('#email').val(), $('#contact').val(),$('#college_name').val(),);

    /* Alerts the results */
    posting.done(function (data) {
      // console.log(data);
      // console.log("1");
      $('#result').text('Thank you we will get back to you');
      $('#result').addClass('alert alert-success');
      $('#result').addClass('mt-1');
      $("#result").show().delay(5000).fadeOut();

      $('#formoid').each(function () {
        this.reset();
        location.href = "https://bangalorestudy.com/thank-you"
      });

    });
    posting.fail(function () {
      // console.log(data);
      // console.log("2");
      $('#result').text('Sorry please try again');
      $('#result').addClass('alert alert-warning');
      $('#result').addClass('mt-1');
      $("#result").show().delay(5000).fadeOut();
      $('#formoid').each(function () {
        this.reset();
      });
    });
  });
  $("#formoid1").submit(function (event) {
    console.log("12");
    /* stop form from submitting normally */
    event.preventDefault();

    /* get the action attribute from the <form action=""> element */
    var $form = $(this),
      url = $form.attr('action');

    /* Send the data using post with element id name and name2*/
    var posting = $.post(url, {
      name: $('#name1').val(),
      email: $('#email1').val(),
      contact: $('#contact1').val(),
      college_name: $('#college_name1').val(),
      current_url: window.location.href,
      // course_in_mind: $('#course_name').val(),
      location: $('#location1').val(),
      // description: $('#description1').val(),

    });

    /* Alerts the results */
    posting.done(function (data) {
      // console.log(data);
      // console.log("1");
      $('#result').text('Thank you we will get back to you');
      $('#result').addClass('alert alert-success');
      $('#result').addClass('mt-1');
      $("#result").show().delay(5000).fadeOut();

      $('#formoid1').each(function () {
        this.reset();
        location.href = "https://bangalorestudy.com/thank-you"
      });

    });
    posting.fail(function () {
      // console.log(data);
      // console.log("2");
      $('#result').text('Sorry please try again');
      $('#result').addClass('alert alert-warning');
      $('#result').addClass('mt-1');
      $("#result").show().delay(5000).fadeOut();
      $('#formoid1').each(function () {
        this.reset();
      });
    });
  });
})


`}
        </script>
        <script type="application/ld+json">
          {JSON.stringify(
            {
              "@context": "https://schema.org",
              "@type": "LocalBusiness",
              "name": "Bangalore Study",
              "image": `${pConfig.siteUrl}home_page/images/logo.png`,
              "@id": `${pConfig.siteUrl}contact`,
              "url": `${pConfig.siteUrl}`,
              "telephone": "+91-9036020016",
              "priceRange": "INR",
              "address": {
                "@type": "PostalAddress",
                "streetAddress": "#3/75, 'D' Main, East End,Jayanagar 9th Block,Bangalore - 560069",
                "addressLocality": "Bengaluru",
                "postalCode": "560069",
                "addressCountry": "IN"
              },
              "geo": {
                "@type": "GeoCoordinates",
                "latitude": 12.918769,
                "longitude": 77.598285
              },
              "openingHoursSpecification": {
                "@type": "OpeningHoursSpecification",
                "dayOfWeek": [
                  "Monday",
                  "Tuesday",
                  "Wednesday",
                  "Thursday",
                  "Friday",
                  "Saturday"
                ],
                "opens": "10:00",
                "closes": "19:00"
              }
            }
          )}
        </script>
        <script>
          {`
        var $titleTab = $('.title_tab');
        $('.Accordion_item:eq(0)').find('.title_tab').addClass('active').next().stop().slideDown(300);
        $('.Accordion_item:eq(0)').find('.inner_content').find('p').addClass('show');
        $titleTab.on('click', function (e) {
            e.preventDefault();
            if ($(this).hasClass('active')) {
                $(this).removeClass('active');
                $(this).next().stop().slideUp(500);
                $(this).next().find('p').removeClass('show');
            } else {
                $(this).addClass('active');
                $(this).next().stop().slideDown(500);
                $(this).parent().siblings().children('.title_tab').removeClass('active');
                $(this).parent().siblings().children('.inner_content').slideUp(500);
                $(this).parent().siblings().children('.inner_content').find('p').removeClass('show');
                $(this).next().find('p').addClass('show');
            }
        });
      `}
        </script>
        <script type="application/ld+json">
          {JSON.stringify(
            {
              "@context": "https://schema.org",
              "@type": "Website",
              "name": "Bangalore Study",
              "url": `${pConfig.siteUrl}`,
              "headline": "Bangalore Study | #1 College Admissions in Bangalore",
              "description": "Bangalorestudy.com by Learntech Edu Solution Pvt. Ltd is an online education platform that operates for counselling students on college admissions",
              "image": {
                "@type": "ImageObject",
                "url": `${pConfig.siteUrl}home_page/images/logo.png`,
                "sameAs": [
                  "https://www.facebook.com/bangalorestudy/",
                  "https://twitter.com/BangaloreStudy2",
                  "https://www.youtube.com/channel/UCZP40_ivVcdelNOVhmQFr7w",
                  "https://www.instagram.com/bangalorestudy/"
                ]
              }
            }
          )}
        </script>

        <script type="application/ld+json">
          {JSON.stringify(
            {
              "@context": "https://schema.org",
              "@type": "FAQPage",
              "mainEntity":
                [{
                  "@type": "Question",
                  "name": "Where is the Mohan Babu University (MBU) located?",
                  "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Mohan Babu University (MBU) is located in Tirupati in Andhra Pradesh."
                  }
                }, {
                  "@type": "Question",
                  "name": "When was the Mohan Babu University (MBU) established?",
                  "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Sree Vidyanikethan Educational Institutions started in 1992 became the Mohan Babu University in 2022."
                  }
                }, {
                  "@type": "Question",
                  "name": "What are the Mohan Babu University courses offered?",
                  "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Mohan Babu University, Tirupati, has 9 schools offering UG and PG programmes in streams such as Engineering, Commerce, Management, Paramedical Sciences, Liberal Arts, Sciences, Art and Design, Agriculture, and Media Studies."
                  }
                }, {
                  "@type": "Question",
                  "name": "How do Mohan Babu University admissions happen?",
                  "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Mohan Babu University admissions are based on marks secured in qualifying exams and other relevant entrance exams. Every year the Mohan Babu University, Tirupati cut-off varies."
                  }
                }, {
                  "@type": "Question",
                  "name": "How is the Mohan Babu University, Tirupati campus?",
                  "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "MBU Tirupati provides a vibrant campus that facilitates overall development of its students. Academic blocks, spacious classrooms, central library, incubation centres, training and placement centre are some of the key features of MBU Tirupati infrastructure and facilities."
                  }
                }, {
                  "@type": "Question",
                  "name": "How are the Mohan Babu University placements?",
                  "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "MBU University, Tirupati, has an excellent placement record with students being placed with some of the highest packages offered in the job market (such as 60 LPA and 37 LPA)."
                  }
                }, {
                  "@type": "Question",
                  "name": "What is the Mohan Babu University NIRF ranking?",
                  "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Mohan Babu University, Tirupati, has secured 165th position in the NIRF rankings."
                  }
                }
                ]
            }
          )}
        </script>

      </Helmet>
      <div className="col-md-12  desktop-view">
        <div className="right-sec">
          <div className="mob-sec cont-sec">
            <a href="tel:+91 9036020016" className='bgred'>
              <span> 9036020016/36/24 &nbsp; &nbsp; </span>
              <i className="fa fa-phone mr-2" />
            </a>
          </div>
        </div>
        <div className="leftse">
          <div className="mail-sec cont-sec">
            <a href="mailto:mohanbabuuniversity56@gmail.com" className='bgred'>
              <span>mohanbabuuniversity56@gmail.com &nbsp; &nbsp; </span>
              <i className="fa fa-envelope" />
            </a>
          </div>
        </div>
      </div>
      <div className="col-md-12 mobile-view">
        <div className="right-sec4">
          <div className="mob-sec cont-sec">
            <a href="tel:+91 9036020016" className='bgred'>
              <i className="fa fa-phone  mr-2" />
            </a>
          </div>
        </div>
        <div className=" right-sec3">
          <div className="mail-sec cont-sec" >
            <a href="mailto:mohanbabuuniversity56@gmail.com" className='bgred'>
              <i className="bi bi-envelope" />
            </a>
          </div>
        </div>
      </div>
      <header>
        <Navbar collapseOnSelect expand="lg" bg="light" fixed="top" variant="light">
          <Container fluid>
            <Navbar.Brand className="hov p-3" ><img
              src={logo}
              width="240"
              height="80"
              className="d-inline-block align-top hov"
              alt="mohan babu iniversity"
            ></img></Navbar.Brand>
            <Navbar.Toggle aria-controls="responsive-navbar-nav" />
            <Navbar.Collapse id="responsive-navbar-nav" className='nav-cutom-yene'>
              <Nav style={{ marginLeft: "auto" }}>
                <Nav.Link href="" className='b' onClick={(e => navigate(e, 'home'))}>Home</Nav.Link>
                <Nav.Link href="" className='b' onClick={(e => navigate(e, 'about'))}>About</Nav.Link>
                <Nav.Link href="" className='b' onClick={(e => navigate(e, 'courses'))}>Courses</Nav.Link>
                <Nav.Link href="" className='b' onClick={(e => navigate(e, 'infrastructure'))}>Infrastructure</Nav.Link>
                <Nav.Link href="" className='b' onClick={(e => navigate(e, 'placements'))}>Placements</Nav.Link>
                <Nav.Link href="" className='b' onClick={(e => navigate(e, 'FAQs'))}>FAQs</Nav.Link>
                <Nav.Link href="" className='b' onClick={(e => navigate(e, 'Contact'))}>Contact</Nav.Link>
              </Nav>
            </Navbar.Collapse>
          </Container>
        </Navbar>
      </header>

      <section className="d-flex align-items-center pb-0 px-0" id="home" style={{ paddingTop: 95 }} >
        {/* <div className="container-fluid bgimage" style={{ background: `url(${ManagementCourseBG})` }}> */}
        <div className="container-fluid bgimage" id="home" style={{ background: `linear-gradient(341deg, rgb(0 0 0 / 0%), rgb(0 0 0 / 0%)) , url(${ManagementCourseBG})` }}>
          <div
            className="container-fluid aos-init aos-animate p-md-2 p-4"
            data-aos="zoom-out"
            data-aos-delay={100}
          >
            <div className="row mt-md-5 pt-md-5" >
              <div className="col-xl-7 col-lg-7 col-md-7 text-center">
                <div className='bgred1 pb-3'>
                  <h1 className='text-center h1mohan'>Mohan Babu University
                    <span className='d-block fontred34'>Dream. Believe. Achieve.</span >
                    {/* <span className='span'>Now in Bangalore!</span> */}
                  </h1>
                  <p className='text-center p font25' >
                    <span className='d-block'>Study at an Academic Institution <br className='d-none d-md-block'/>
                    that Invests in Your Growth.</span>

                  </p>
                  <p className='text-center p font35' >Admissions Open!
                  </p>
                  <Button className="button" value="brochure" onClick={handleShow}>
                    <><GetAppIcon /> Download Brochure</>
                  </Button>
                </div>
                {/* <button type="button" className="btn btn-success mb-4">Apply Now!</button> */}
              </div>
              <div className="col-xl-5 col-lg-5 col-md-5">

                <div className="form-boxmohan p-md-4 mt-3 mt-md-0">
                  <div>
                    <h3
                      className="font-weight-bold pb-3"
                      style={{ color: "rgb(255 229 8)", textAlign: "center", fontWeight: 900 }}
                    >
                      Get Started with
                      Your Application Process.

                    </h3>
                  </div>
                  
                  <EnquiryForm />
                 

                  {/* <form id="formoid"
                    action="https://api.bangalorestudy.com:3000/api/website/home/landingpageenquiry"
                    title=""
                    method="post">
                    <div className="form-group mb-3">

                      <input
                        type="text"
                        id="name"
                        name="name"
                        placeholder="Name*"
                        required
                        className="form-control"
                      />

                    </div>
                    <div className="form-group mb-3">
                      <input
                        className="form-control"
                        id="email"
                        type="email"
                        name="email"
                        placeholder="Your Email "
                        required
                      />
                    </div>
                    <div className="form-group mb-3">
                      <input
                        className="form-control"
                        name="contact"
                        id="contact"
                        type="number"

                        required
                        placeholder="Contact No. * "
                      />
                    </div>

                    <div className="form-group mb-3">
                      <select
                        className="browser-default custom-select form-control"
                        name="location"
                        id="location"
                        required
                      >
                        <option value=" ">State</option>
                        <option value="Andhra Pradesh ">Andhra Pradesh</option>
                        <option value="Arunachal Pradesh ">Arunachal Pradesh</option>
                        <option value="Assam ">Assam</option>
                        <option value="Bihar ">Bihar</option>
                        <option value="Chhattisgarh ">Chhattisgarh</option>
                        <option value="Goa ">Goa</option>
                        <option value="Gujarat ">Gujarat</option>
                        <option value="Haryana ">Haryana</option>
                        <option value="Himachal Pradesh ">Himachal Pradesh</option>
                        <option value="Jammu & Kashmir ">Jammu &amp; Kashmir</option>
                        <option value="Jharkhand ">Jharkhand</option>
                        <option value="Karnataka ">Karnataka</option>
                        <option value="Kerala ">Kerala</option>
                        <option value="Madhya Pradesh ">Madhya Pradesh</option>
                        <option value="Maharashtra ">Maharashtra</option>
                        <option value="Manipur ">Manipur</option>
                        <option value="Meghalaya ">Meghalaya</option>
                        <option value="Mizoram ">Mizoram</option>
                        <option value="Nagaland ">Nagaland</option>
                        <option value="Odisha ">Odisha</option>
                        <option value="Punjab ">Punjab</option>
                        <option value="Rajasthan ">Rajasthan</option>
                        <option value="Sikkim ">Sikkim</option>
                        <option value="Tamil Nadu ">Tamil Nadu</option>
                        <option value="Tripura ">Tripura</option>
                        <option value="Telangana ">Telangana</option>
                        <option value="Uttarakhand ">Uttarakhand</option>
                        <option value="Uttar Pradesh ">Uttar Pradesh</option>
                        <option value="West Bengal ">West Bengal</option>
                        <option value="Andaman & Nicobar ">
                          Andaman &amp; Nicobar
                        </option>
                        <option value="Chandigarh ">Chandigarh</option>
                        <option value="Dadra and Nagar Haveli ">
                          Dadra and Nagar Haveli
                        </option>
                        <option value="Daman & Diu ">Daman &amp; Diu</option>
                        <option value="Delhi ">Delhi</option>
                        <option value="Lakshadweep ">Lakshadweep</option>
                        <option value="Puducherry ">Puducherry</option>
                      </select>
                    </div>

                    <div className="form-group mb-3">
                      <input
                        className="form-control"
                        id="course_name"
                        type="text"
                        name="course_name"
                        placeholder="Interested Course"
                        required
                      />
                    </div>
      
                    <div className="form-group mb-3">
                      <textarea

                        cols={3}
                        name="description"
                        id="description"
                        placeholder="Message (optional) "
                        className="form-control"
                        defaultValue={""}
                      />
                    </div>
                    <div className="form-group text-center">
                      <button className="button" name="submit" defaultValue="Submit" type="submit">Submit</button>

                    </div>
                  </form> */}
                  
                </div>

              </div>
            </div>


          </div>
        </div>
      </section>

      <section className="container-fluid  pb-0 pt-3 ">
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-12 text-center">
              <h3 className='fh3mohan'>Mohan Babu University
              </h3>
              <p className='mb-0'>Formerly Sree Vidyanikethan Educational Institutions
              </p>

              <OwlCarousel {...owlOptions} className="topTrendingCourses loop_nav owl-carousel owl-theme ">



                <div className="item">

                  <img src={acc1} className="customimage" alt="accredation1" />
                </div>
                <div className="item">

                  <img src={acc2} className="customimage" alt="accredation2" />
                </div>
                <div className="item">

                  <img src={acc3} className="customimage" alt="accredation3" />
                </div>
                <div className="item">

                  <img src={acc4} className="customimage" alt="accredation4" />
                </div>
                <div className="item">

                  <img src={acc5} className="customimage" alt="accredation5" />
                </div>
                <div className="item">

                  <img src={acc6} className="customimage" alt="accredation6" />
                </div>




              </OwlCarousel>
            </div>
          </div>
          <div className='container'>
            <div className="row  flex-md-row-reverse align-items-center">

              <div className="col-xl-6 col-lg-6 col-md-6 text-center p-sm-5  ">



                <h3 className='fh3mohan'>Mohan Babu University, Tirupati
                </h3>
                <p className='pt-3 pb-3 pb-md-0'>Mohan Babu University (MBU) is a multidisciplinary educational institution located in Tirupati, Andhra Pradesh. With the noble aim of contributing to the development of the society, Mohan Babu University strives to inspire young learners and build a community of professionals who contribute to the betterment of the society. MBU offers UG and PG programmes in a wide range of streams with an advanced curriculum, state-of-the-art infrastructure and expert mentorship that facilitates academic excellence.</p>
                {/* <p className='pb-3'>Let’s take a tour of the new Yenepoya (Deemed-to-be University) Bhartiya City, Bangalore campus!</p> */}
              </div >
              <div className="col-xl-6 col-lg-6 col-md-6 text-center  ">
                <img src={Video} className="imgres" alt="loading..." />





              </div>

            </div >

          </div>
          <div className='container-fluid'>
            <div className="row pt-3 flex-md-row-reverse align-items-center">

              <div className="col-lg-12 text-center">
                <h3 className='fh3mohan '>MBU University Core Values</h3>
              </div>

              <div className="col-lg-12 text-center pt-3"><div className="card-deck">
                <div className="row row-cols-1 row-cols-md-4 g-3">
                  <div className='col'>

                    <div className="card  position-relative card-body-background ">
                      <img className="card-img-top" src={Skill} alt="Skill Development" height="182px" />
                      <div className="card-body">
                        <h5 className="card-title">Skill Development</h5>
                      </div>
                    </div></div>
                  <div className='col'>
                    <div className="card  position-relative card-body-background ">
                      <img className="card-img-top" src={value} alt="Value Orientation" height="182px" />
                      <div className="card-body">
                        <h5 className="card-title">Value Orientation</h5>

                      </div>
                    </div>
                  </div>
                  <div className='col'>
                    <div className="card  position-relative card-body-background">
                      <img className="card-img-top" src={experimental} alt="Experiential Learning" height="182px" />
                      <div className="card-body">
                        <h5 className="card-title">Experiential Learning</h5>

                      </div>
                    </div>
                  </div>
                 
                  <div className='col'>
                    <div className="card  position-relative card-body-background"  >
                      <img className="card-img-top" src={Research} alt="Research Development" height="182px"  
                      id ="courses" />
                      <div className="card-body" >
                        <h5 className="card-title "  >Research Development</h5>
                        {/* <span id ="courses"style={{ display: "hidden" }}></span> */}
                      </div>
                    </div>
                  </div>

                 


                </div>

              </div>
              </div>
            </div>


          </div >
        </div >

      </section >

      <section className="container-fluid pb-0" >
        <div className="container pt-3 pt-md-0">
          <div className="row">
            <div className="col-lg-12 text-center">
              <h3 className='fh3mohan '>Mohan Babu University Courses</h3>
            </div>

            <div className="col-lg-12 text-center pt-3"><p>Mohan Babu University Courses are structured in a way that transforms young minds into dynamic and knowledgeable professionals. With the right mix of theoretical knowledge and practical application, the curriculum of Mohan Babu University courses ensures that students gain an in-depth understanding of concepts which enables them to shine in their chosen fields.As a cherry on the cake,the MBU University, Tirupati, fee structure is nominal, making quality education accessible to students from all sections of the society.<br /> <br /> Let’s have a look at the Mohan Babu University, Tirupati, courses offered.</p></div>
          </div>
        </div>

        <div className="container-fluid pt-3 pt-md-0">
          <div className="row">
            <div className="col-lg-12 text-center  pt-3">
              <div className="row">
                <OwlCarousel {...owlOptions} className="topTrendingCourses loop_nav owl-carousel owl-theme ">



                  <div className="item">
                    <div className="card card-body-background">
                      <img
                        className="img-fluid"
                        alt="Engineering"
                        src={Engineering}
                      />
                      <div className="card-body">
                        <h5 className="card-title">Engineering</h5>
                      </div>
                    </div>

                  </div>
                  <div className="item">
                    <div className="card card-body-background">
                      <img
                        className="img-fluid"
                        alt="Computer Applications"
                        src={computer}
                      />
                      <div className="card-body">
                        <h5 className="card-title">Computer Applications</h5>
                      </div>
                    </div>

                  </div>
                  <div className="item">
                    <div className="card card-body-background">
                      <img
                        className="img-fluid"
                        alt="Management"
                        src={Management}
                      />
                      <div className="card-body">
                        <h5 className="card-title">Management</h5>
                      </div>
                    </div>

                  </div>


                  <div className="item">
                    <div className="card card-body-background">
                      <img
                        className="img-fluid"
                        alt="Commerce"
                        src={Commerce}
                      />
                      <div className="card-body">
                        <h5 className="card-title">Commerce</h5>
                      </div>
                    </div>

                  </div>

                  <div className="item">
                    <div className="card card-body-background">
                      <img
                        className="img-fluid"
                        alt="Nursing"
                        src={Nursing}
                      />
                      <div className="card-body">
                        <h5 className="card-title">Nursing</h5>
                      </div>
                    </div>

                  </div>

                  <div className="item">
                    <div className="card card-body-background">
                      <img
                        className="img-fluid"
                        alt="Allied Health Sciences"
                        src={Paramedical}
                      />
                      <div className="card-body">
                        <h5 className="card-title">Allied Health Sciences</h5>
                      </div>
                    </div>

                  </div>

                  <div className="item">
                    <div className="card card-body-background">
                      <img
                        className="img-fluid"
                        alt="Physiotherapy"
                        src={Physiotherapy}
                      />
                      <div className="card-body">
                        <h5 className="card-title">Physiotherapy</h5>
                      </div>
                    </div>

                  </div>
                  <div className="item">
                    <div className="card card-body-background">
                      <img
                        className="img-fluid"
                        alt="Pharmacy"
                        src={Pharmacy}
                      />
                      <div className="card-body">
                        <h5 className="card-title">Pharmacy</h5>
                      </div>
                    </div>

                  </div>



                  {/* <div className="item">
                    <div className="card card-body-background">
                      <img
                        className="img-fluid"
                        alt="Banking & Finance"
                        src={Banking}
                      />
                      <div className="card-body">
                        <h5 className="card-title">Banking & Finance</h5>
                      </div>
                    </div>

                  </div> */}
                  <div className="item">
                    <div className="card card-body-background">
                      <img
                        className="img-fluid"
                        alt="Biotechnology"
                        src={Biotechnology}
                      />
                      <div className="card-body">
                        <h5 className="card-title">Biotechnology</h5>
                      </div>
                    </div>

                  </div>
                  <div className="item">
                    <div className="card card-body-background">
                      <img
                        className="img-fluid"
                        alt="Agriculture"
                        src={Agriculture}
                      />
                      <div className="card-body">
                        <h5 className="card-title">Agriculture</h5>
                      </div>
                    </div>

                  </div>
                  {/* <div className="item">
                    <div className="card card-body-background">
                      <img
                        className="img-fluid"
                        alt="Visual Communication"
                        src={VisualCommunication}
                      />
                      <div className="card-body">
                        <h5 className="card-title">Visual Communication</h5>
                      </div>
                    </div>

                  </div> */}
                  {/* <div className="item">
                    <div className="card card-body-background">
                      <img
                        className="img-fluid"
                        alt="Food Science & Technology"
                        src={Food}
                      />
                      <div className="card-body">
                        <h5 className="card-title">Food Science & Technology</h5>
                      </div>
                    </div>

                  </div> */}
                  {/* <div className="item">
                    <div className="card card-body-background">
                      <img
                        className="img-fluid"
                        alt="Animation & VFX"
                        src={Animation}
                      />
                      <div className="card-body">
                        <h5 className="card-title">Animation & VFX</h5>
                      </div>
                    </div>

                  </div> */}
                  <div className="item">
                    <div className="card card-body-background">
                      <img
                        className="img-fluid"
                        alt="Filmmaking"
                        src={Filmmaking}
                      />
                      <div className="card-body">
                        <h5 className="card-title">Filmmaking</h5>
                      </div>
                    </div>

                  </div>
                  {/* <div className="item">
                    <div className="card card-body-background">
                      <img
                        className="img-fluid"
                        alt="Performing Arts"
                        src={Performing}
                      />
                      <div className="card-body">
                        <h5 className="card-title">Performing Arts</h5>
                      </div>
                    </div>

                  </div> */}
                </OwlCarousel>


              </div>
            </div>
          </div>
          <div className="container">
            <div className="row">
              <div className="col-lg-12 text-center  pt-3">
                <h3 className='fh3mohan pb-4'>List of Courses in Mohan Babu University, Tirupati</h3>

                <div id="lefttabs-block">
                  <div className="col-md-3 col-lg-3 left-tabs-nav-widgets d-none d-sm-block d-lg-block d-md-block" >
                    <ul className="nav nav-tabs" id="myTab">

                      <li className="nav-item"><a href="#sh1" className="nav-link active f700" data-bs-toggle="tab">School of Engineering & Computing</a></li>
                      <li className="nav-item"><a href="#sh2" className="nav-link f700" data-bs-toggle="tab">School of Liberal Arts & Sciences</a></li>
                      <li className="nav-item"><a href="#sh3" className="nav-link f700" data-bs-toggle="tab">School of Commerce & Management</a></li>
                      <li className="nav-item"><a href="#sh4" className="nav-link f700" data-bs-toggle="tab">School of Paramedical, Allied & Healthcare Sciences</a></li>
                      <li className="nav-item"><a href="#sh5" className="nav-link f700" data-bs-toggle="tab">School of Nursing</a></li>
                      <li className="nav-item"><a href="#sh6" className="nav-link f700" data-bs-toggle="tab">School of Pharmaceutical Sciences</a></li>
                      <li className="nav-item"><a href="#sh7" className="nav-link f700" data-bs-toggle="tab">School of Agriculture</a></li>
                      <li className="nav-item"><a href="#sh8" className="nav-link f700" data-bs-toggle="tab">Film Academy</a></li>
                    </ul>
                  </div>

                  <div className="col-md-9 col-lg-9 right-content-widgets mynewclass mynewclasslandingpage" >


                    <Hidden lgUp mdUp smUp>

                      <Accordion>
                        <AccordionSummary
                          expandIcon={<ExpandMoreIcon />}
                          aria-controls="panel1a-content"
                          id={`panel1a-header`}
                        >
                          <Typography className='f700 ff23'>School of Engineering & Computing</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                          <div className='d-flex flex-wrap'>

                            <div className="card  w-100" >
                              <div className="card-body card-body-background p-2">
                                <h5 className="card-title">UG</h5>
                              </div>
                              <ul className="list-group list-group-flush ">
                                <li className="list-group-item  p-1 fw-bold"><div className='fw-bold d-inline'>B.Tech Computer Science & Engineering (CSE)</div> <div className='fright'><i className="bi bi-clock colorred"></i>  &nbsp;4 Years  <Button className="btnlist " onClick={handleShow}>
                                  Apply Now!
                                </Button></div> </li>
                                <li className="list-group-item  p-1 fw-bold"><div className='fw-bold d-inline'>B.Tech CSE Artificial Intelligence & Machine Learning
                                </div> <div className='fright'><i className="bi bi-clock colorred"></i>  &nbsp;4 Years  <Button className="btnlist " onClick={handleShow}>
                                  Apply Now!
                                </Button></div> </li>
                                <li className="list-group-item  p-1 fw-bold"><div className='fw-bold d-inline'>B.Tech CSE Cyber Security</div> <div className='fright'><i className="bi bi-clock colorred"></i>  &nbsp;4 Years  <Button className="btnlist " onClick={handleShow}>
                                  Apply Now!
                                </Button></div> </li>
                                <li className="list-group-item  p-1 fw-bold"><div className='fw-bold d-inline'>
                                  B.Tech CSE Data Science
                                </div> <div className='fright'><i className="bi bi-clock colorred"></i>  &nbsp;4 Years  <Button className="btnlist " onClick={handleShow}>
                                  Apply Now!
                                </Button></div> </li>
                                <li className="list-group-item  p-1 fw-bold"><div className='fw-bold d-inline'>
                                  B.Tech Computer Science and Information Technology
                                </div> <div className='fright'><i className="bi bi-clock colorred"></i>  &nbsp;4 Years  <Button className="btnlist " onClick={handleShow}>
                                  Apply Now!
                                </Button></div> </li>
                                <li className="list-group-item  p-1 fw-bold"><div className='fw-bold d-inline'>
                                  B.Tech Electrical & Electronics Engineering (EEE)
                                </div> <div className='fright'><i className="bi bi-clock colorred"></i>  &nbsp;4 Years  <Button className="btnlist " onClick={handleShow}>
                                  Apply Now!
                                </Button></div> </li>
                                <li className="list-group-item  p-1 fw-bold"><div className='fw-bold d-inline'>
                                  B.Tech Electronics & Communication Engineering (ECE)
                                </div> <div className='fright'><i className="bi bi-clock colorred"></i>  &nbsp;4 Years  <Button className="btnlist " onClick={handleShow}>
                                  Apply Now!
                                </Button></div> </li>
                                <li className="list-group-item  p-1 fw-bold"><div className='fw-bold d-inline'>
                                  B.Tech Electronics & Instrumentation Engineering (EIE)
                                </div> <div className='fright'><i className="bi bi-clock colorred"></i>  &nbsp;4 Years  <Button className="btnlist " onClick={handleShow}>
                                  Apply Now!
                                </Button></div> </li>
                                <li className="list-group-item  p-1 fw-bold"><div className='fw-bold d-inline'>
                                  B.Tech Mechanical Engineering
                                </div> <div className='fright'><i className="bi bi-clock colorred"></i>  &nbsp;4 Years  <Button className="btnlist " onClick={handleShow}>
                                  Apply Now!
                                </Button></div> </li>
                                <li className="list-group-item  p-1 fw-bold"><div className='fw-bold d-inline'>
                                  B.Tech Civil Engineering
                                </div> <div className='fright'><i className="bi bi-clock colorred"></i>  &nbsp;4 Years  <Button className="btnlist " onClick={handleShow}>
                                  Apply Now!
                                </Button></div> </li>
                                <li className="list-group-item  p-1 fw-bold"><div className='fw-bold d-inline'>
                                  BCA (Bachelor of Computer Applications)
                                </div> <div className='fright'><i className="bi bi-clock colorred"></i>  &nbsp;3 Years  <Button className="btnlist " onClick={handleShow}>
                                  Apply Now!
                                </Button></div> </li>
                              </ul>

                            </div>
                            <div className="card mt-2 w-100" >
                              <div className="card-body card-body-background p-2">
                                <h5 className="card-title">PG</h5>
                              </div>
                              <ul className="list-group list-group-flush">
                                <li className="list-group-item  p-1 fw-bold"><div className='fw-bold d-inline'>
                                  M.Tech Construction Technology & Management
                                </div> <div className='fright'><i className="bi bi-clock colorred"></i>  &nbsp;2 Years  <Button className="btnlist " onClick={handleShow}>
                                  Apply Now!
                                </Button></div> </li>
                                <li className="list-group-item  p-1 fw-bold"><div className='fw-bold d-inline'>
                                  M.Tech Electrical Power Systems
                                </div> <div className='fright'><i className="bi bi-clock colorred"></i>  &nbsp;2 Years  <Button className="btnlist " onClick={handleShow}>
                                  Apply Now!
                                </Button></div> </li>
                                <li className="list-group-item  p-1 fw-bold"><div className='fw-bold d-inline'>
                                  M.Tech Machine Design
                                </div> <div className='fright'><i className="bi bi-clock colorred"></i>  &nbsp;2 Years  <Button className="btnlist " onClick={handleShow}>
                                  Apply Now!
                                </Button></div> </li>


                                <li className="list-group-item  p-1 fw-bold"><div className='fw-bold d-inline'>
                                  M.Tech VLSI & Embedded System Design
                                </div> <div className='fright'><i className="bi bi-clock colorred"></i>  &nbsp;2 Years  <Button className="btnlist " onClick={handleShow}>
                                  Apply Now!
                                </Button></div> </li>
                                <li className="list-group-item  p-1 fw-bold"><div className='fw-bold d-inline'>
                                  MCA (Master of Computer Applications)
                                </div> <div className='fright'><i className="bi bi-clock colorred"></i>  &nbsp;2 Years  <Button className="btnlist " onClick={handleShow}>
                                  Apply Now!
                                </Button></div> </li>





                              </ul>

                            </div>

                          </div>
                        </AccordionDetails>
                      </Accordion>

                      <Accordion>
                        <AccordionSummary
                          expandIcon={<ExpandMoreIcon />}
                          aria-controls="panel1a-content"
                          id={`panel1a-header`}

                        >
                          <Typography className='mauto f700 ff23'>School of Liberal Arts & Sciences
                          </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                          <div className='d-flex flex-wrap'>
                            <div className="card w-100 " >
                              <div className="card-body card-body-background p-2">
                                <h5 className="card-title">UG</h5>
                              </div>
                              <ul className="list-group list-group-flush">

                                <li className="list-group-item  p-1 fw-bold"><div className='fw-bold d-inline'>
                                  B.Sc Bioinformatics</div> <div className='fright'><i className="bi bi-clock colorred"></i>  &nbsp;3 Years  <Button className="btnlist " onClick={handleShow}>
                                    Apply Now!
                                  </Button></div> </li>
                                <li className="list-group-item  p-1 fw-bold"><div className='fw-bold d-inline'>
                                  B.Sc Biotechnology</div> <div className='fright'><i className="bi bi-clock colorred"></i>  &nbsp;3 Years  <Button className="btnlist " onClick={handleShow}>
                                    Apply Now!
                                  </Button></div> </li>
                                <li className="list-group-item  p-1 fw-bold"><div className='fw-bold d-inline'>
                                  B.Sc Computer Science</div> <div className='fright'><i className="bi bi-clock colorred"></i>  &nbsp;3 Years  <Button className="btnlist " onClick={handleShow}>
                                    Apply Now!
                                  </Button></div> </li>
                                <li className="list-group-item  p-1 fw-bold"><div className='fw-bold d-inline'>
                                  B.Sc Microbiology</div> <div className='fright'><i className="bi bi-clock colorred"></i>  &nbsp;3 Years  <Button className="btnlist " onClick={handleShow}>
                                    Apply Now!
                                  </Button></div> </li>

                                <li className="list-group-item  p-1 fw-bold"><div className='fw-bold d-inline'>
                                  B.Sc Forensic Sciences</div> <div className='fright'><i className="bi bi-clock colorred"></i>  &nbsp;3 Years  <Button className="btnlist " onClick={handleShow}>
                                    Apply Now!
                                  </Button></div> </li>
                              </ul>

                            </div>
                            <div className="card mt-2 w-100" >
                              <div className="card-body card-body-background p-2">
                                <h5 className="card-title">PG</h5>
                              </div>
                              <ul className="list-group list-group-flush">

                                <li className="list-group-item  p-1 fw-bold"><div className='fw-bold d-inline'>
                                  M.Sc Biotechnology
                                </div> <div className='fright'><i className="bi bi-clock colorred"></i>  &nbsp;2 Years  <Button className="btnlist " onClick={handleShow}>
                                  Apply Now!
                                </Button></div> </li>
                                <li className="list-group-item  p-1 fw-bold"><div className='fw-bold d-inline'>
                                  M.Sc Computer Science
                                </div> <div className='fright'><i className="bi bi-clock colorred"></i>  &nbsp;2 Years  <Button className="btnlist " onClick={handleShow}>
                                  Apply Now!
                                </Button></div> </li>
                                <li className="list-group-item  p-1 fw-bold"><div className='fw-bold d-inline'>
                                  M.Sc Organic Chemistry
                                </div> <div className='fright'><i className="bi bi-clock colorred"></i>  &nbsp;2 Years  <Button className="btnlist " onClick={handleShow}>
                                  Apply Now!
                                </Button></div> </li>
                              </ul>

                            </div>
                          </div>
                        </AccordionDetails>
                      </Accordion>

                      <Accordion>
                        <AccordionSummary
                          expandIcon={<ExpandMoreIcon />}
                          aria-controls="panel1a-content"
                          id={`panel1a-header`}
                        >
                          <Typography className='f700 ff23'>School of Commerce & Management</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                          <div className='d-flex flex-wrap'>

                          <div className="card w-100 " >
                          <div className="card-body card-body-background p-2">
                            <h5 className="card-title">UG</h5>
                          </div>
                          <ul className="list-group list-group-flush">
                            <li className="list-group-item  p-1 fw-bold"><div className='fw-bold d-inline'>
                              B.Com Computer Applications</div> <div className='fright'><i className="bi bi-clock colorred"></i>  &nbsp;3 Years  <Button className="btnlist " onClick={handleShow}>
                                Apply Now!
                              </Button></div> </li>
                            <li className="list-group-item  p-1 fw-bold"><div className='fw-bold d-inline'>BBA General</div> <div className='fright'><i className="bi bi-clock colorred"></i>  &nbsp;3 Years  <Button className="btnlist " onClick={handleShow}>
                              Apply Now!
                            </Button></div> </li>
                          </ul>

                        </div>
                        <div className="card mt-2 w-100" >
                          <div className="card-body card-body-background p-2">
                            <h5 className="card-title">PG</h5>
                          </div>
                          <ul className="list-group list-group-flush">
                            <li className="list-group-item  p-1 fw-bold"><div className='fw-bold d-inline'>
                              MBA Marketing
                            </div> <div className='fright'><i className="bi bi-clock colorred"></i>  &nbsp;2 Years  <Button className="btnlist " onClick={handleShow}>
                              Apply Now!
                            </Button></div> </li>
                            <li className="list-group-item  p-1 fw-bold"><div className='fw-bold d-inline'>
                              MBA HR
                            </div> <div className='fright'><i className="bi bi-clock colorred"></i>  &nbsp;2 Years  <Button className="btnlist " onClick={handleShow}>
                              Apply Now!
                            </Button></div> </li>
                            <li className="list-group-item  p-1 fw-bold"><div className='fw-bold d-inline'>
                              MBA Finance
                            </div> <div className='fright'><i className="bi bi-clock colorred"></i>  &nbsp;2 Years  <Button className="btnlist " onClick={handleShow}>
                              Apply Now!
                            </Button></div> </li>

                          </ul>

                        </div>

                          </div>
                        </AccordionDetails>
                      </Accordion>

                      <Accordion>
                        <AccordionSummary
                          expandIcon={<ExpandMoreIcon />}
                          aria-controls="panel1a-content"
                          id={`panel1a-header`}
                        >
                          <Typography className='f700 ff23'>School of Paramedical, Allied & Healthcare Sciences</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                          <div className='d-flex flex-wrap'>

                          <div className="card w-100 " >
                          <div className="card-body card-body-background p-2">
                            <h5 className="card-title">UG</h5>
                          </div>
                          <ul className="list-group list-group-flush">




                            <li className="list-group-item  p-1 fw-bold"><div className='fw-bold d-inline'>
                              B.Sc Anaesthesia & Operation Theatre Technology
                            </div> <div className='fright'><i className="bi bi-clock colorred"></i>  &nbsp;3  Years  <Button className="btnlist " onClick={handleShow}>
                              Apply Now!
                            </Button></div> </li>
                            <li className="list-group-item  p-1 fw-bold"><div className='fw-bold d-inline'>
                              B.Sc Cardio Vascular Technology
                            </div> <div className='fright'><i className="bi bi-clock colorred"></i>  &nbsp;3  Years  <Button className="btnlist " onClick={handleShow}>
                              Apply Now!
                            </Button></div> </li>
                            <li className="list-group-item  p-1 fw-bold"><div className='fw-bold d-inline'>
                              B.Sc Dialysis Technology
                            </div> <div className='fright'><i className="bi bi-clock colorred"></i>  &nbsp;3  Years  <Button className="btnlist " onClick={handleShow}>
                              Apply Now!
                            </Button></div> </li>
                            <li className="list-group-item  p-1 fw-bold"><div className='fw-bold d-inline'>
                              B.Sc Emergency Medicine & Critical Care Technology
                            </div> <div className='fright'><i className="bi bi-clock colorred"></i>  &nbsp;3  Years  <Button className="btnlist " onClick={handleShow}>
                              Apply Now!
                            </Button></div> </li>
                            <li className="list-group-item  p-1 fw-bold"><div className='fw-bold d-inline'>
                              B.Sc Respiratory Therapy
                            </div> <div className='fright'><i className="bi bi-clock colorred"></i>  &nbsp;3  Years  <Button className="btnlist " onClick={handleShow}>
                              Apply Now!
                            </Button></div> </li>
                            <li className="list-group-item  p-1 fw-bold"><div className='fw-bold d-inline'>
                              B.Sc Medical Lab Technology
                            </div> <div className='fright'><i className="bi bi-clock colorred"></i>  &nbsp;3  Years  <Button className="btnlist " onClick={handleShow}>
                              Apply Now!
                            </Button></div> </li>
                            <li className="list-group-item  p-1 fw-bold"><div className='fw-bold d-inline'>
                              B.Sc Optometry
                            </div> <div className='fright'><i className="bi bi-clock colorred"></i>  &nbsp;3  Years  <Button className="btnlist " onClick={handleShow}>
                              Apply Now!
                            </Button></div> </li>
                            <li className="list-group-item  p-1 fw-bold"><div className='fw-bold d-inline'>
                              B.Sc Radiology & Imaging Technology
                            </div> <div className='fright'><i className="bi bi-clock colorred"></i>  &nbsp;3  Years  <Button className="btnlist " onClick={handleShow}>
                              Apply Now!
                            </Button></div> </li>
                            <li className="list-group-item  p-1 fw-bold"><div className='fw-bold d-inline'>
                              BPT (Bachelor of Physiotherapy)
                            </div> <div className='fright'><i className="bi bi-clock colorred"></i>  &nbsp;4  Years  <Button className="btnlist " onClick={handleShow}>
                              Apply Now!
                            </Button></div> </li>

                          </ul>

                        </div>
                        <div className="card mt-2 w-100" >
                          <div className="card-body card-body-background p-2">
                            <h5 className="card-title">PG</h5>
                          </div>
                          <ul className="list-group list-group-flush">

                            <li className="list-group-item  p-1 fw-bold"><div className='fw-bold d-inline'>
                              MPT (Physiotherapy - Neurology)
                            </div> <div className='fright'><i className="bi bi-clock colorred"></i>  &nbsp;2 Years  <Button className="btnlist " onClick={handleShow}>
                              Apply Now!
                            </Button></div> </li>
                            <li className="list-group-item  p-1 fw-bold"><div className='fw-bold d-inline'>
                              MPT (Physiotherapy - Orthopaedics)
                            </div> <div className='fright'><i className="bi bi-clock colorred"></i>  &nbsp;2 Years  <Button className="btnlist " onClick={handleShow}>
                              Apply Now!
                            </Button></div> </li>
                            <li className="list-group-item  p-1 fw-bold"><div className='fw-bold d-inline'>
                              MPT (Physiotherapy - Cardio Pulmonary)
                            </div> <div className='fright'><i className="bi bi-clock colorred"></i>  &nbsp;2 Years  <Button className="btnlist " onClick={handleShow}>
                              Apply Now!
                            </Button></div> </li>
                            <li className="list-group-item  p-1 fw-bold"><div className='fw-bold d-inline'>
                              MPT (Physiotherapy - Sports)
                            </div> <div className='fright'><i className="bi bi-clock colorred"></i>  &nbsp;2 Years  <Button className="btnlist " onClick={handleShow}>
                              Apply Now!
                            </Button></div> </li>
                          </ul>

                        </div>
                          </div>
                        </AccordionDetails>
                      </Accordion>

                      <Accordion>
                        <AccordionSummary
                          expandIcon={<ExpandMoreIcon />}
                          aria-controls="panel1a-content"
                          id={`panel1a-header`}
                        >
                           <Typography className='f700 ff23'>School of Nursing</Typography>
                          {/* <Typography className=' mautof700 ff23'>School of Nursing</Typography> */}
                        </AccordionSummary>
                        <AccordionDetails>
                          <div className='d-flex flex-wrap'>

                          <div className="card w-100 " >
                          {/* <div className="card-body card-body-background p-2">
                            <h5 className="card-title">UG</h5>
                          </div> */}
                          <ul className="list-group list-group-flush">
                            <li className="list-group-item  p-1 fw-bold"><div className='fw-bold d-inline'>
                              School of Nursing

                            </div> <div className='fright'><Button className="btnlist " onClick={handleShow}>
                              Apply Now!
                            </Button></div> </li>
                          </ul>

                        </div>
                          </div>
                        </AccordionDetails>
                      </Accordion>

                      <Accordion>
                        <AccordionSummary
                          expandIcon={<ExpandMoreIcon />}
                          aria-controls="panel1a-content"
                          id={`panel1a-header`}
                        >
                          <Typography className="f700 ff23">School of Pharmaceutical Sciences</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                          <div className='d-flex flex-wrap'>

                          <div className="card w-100 " >
                          <div className="card-body card-body-background p-2">
                            <h5 className="card-title">UG</h5>
                          </div>
                          <ul className="list-group list-group-flush">
                            <li className="list-group-item  p-1 fw-bold"><div className='fw-bold d-inline'>
                              B.Pharmacy

                            </div> <div className='fright'><i className="bi bi-clock colorred"></i>  &nbsp;4 Years  <Button className="btnlist " onClick={handleShow}>
                              Apply Now!
                            </Button></div> </li>
                          </ul>

                        </div>

                        <div className="card mt-2 w-100" >
                          <div className="card-body card-body-background p-2">
                            <h5 className="card-title">PG</h5>
                          </div>
                          <ul className="list-group list-group-flush">

                            <li className="list-group-item  p-1 fw-bold"><div className='fw-bold d-inline'>
                              M.Pharmacy (Pharmaceutics)
                            </div> <div className='fright'><i className="bi bi-clock colorred"></i>  &nbsp;2 Years  <Button className="btnlist " onClick={handleShow}>
                              Apply Now!
                            </Button></div> </li>
                            <li className="list-group-item  p-1 fw-bold"><div className='fw-bold d-inline'>
                              M.Pharmacy (Pharmaceutical Analysis)
                            </div> <div className='fright'><i className="bi bi-clock colorred"></i>  &nbsp;2 Years  <Button className="btnlist " onClick={handleShow}>
                              Apply Now!
                            </Button></div> </li>
                            <li className="list-group-item  p-1 fw-bold"><div className='fw-bold d-inline'>
                              Pharm.D
                            </div> <div className='fright'><i className="bi bi-clock colorred"></i>  &nbsp;6 Years  <Button className="btnlist " onClick={handleShow}>
                              Apply Now!
                            </Button></div> </li>
                            <li className="list-group-item  p-1 fw-bold"><div className='fw-bold d-inline'>
                              Pharm.D (Post Baccalaureate)
                            </div> <div className='fright'><i className="bi bi-clock colorred"></i>  &nbsp;3 Years  <Button className="btnlist " onClick={handleShow}>
                              Apply Now!
                            </Button></div> </li>
                          </ul>

                        </div>
                          </div>
                        </AccordionDetails>
                      </Accordion>


                      <Accordion>
                        <AccordionSummary
                          expandIcon={<ExpandMoreIcon />}
                          aria-controls="panel1a-content"
                          id={`panel1a-header`}
                        >
                          <Typography className='mauto f700 ff23'>School of Agriculture</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                          <div className='d-flex flex-wrap'>

                          <div className="card w-100 " >
                          <div className="card-body card-body-background p-2">
                            <h5 className="card-title">UG</h5>
                          </div>
                          <ul className="list-group list-group-flush">



                            <li className="list-group-item  p-1 fw-bold"><div className='fw-bold d-inline'>
                              B.Sc (Hons.) Agriculture
                            </div> <div className='fright'><i className="bi bi-clock colorred"></i>  &nbsp;4 Years  <Button className="btnlist " onClick={handleShow}>
                              Apply Now!
                            </Button></div> </li>
                          </ul>

                        </div>

                          </div>
                        </AccordionDetails>
                      </Accordion>

                      <Accordion>
                        <AccordionSummary
                          expandIcon={<ExpandMoreIcon />}
                          aria-controls="panel1a-content"
                          id={`panel1a-header`}
                        >
                          <Typography className='mauto f700 ff23'>Film Academy</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                          <div className='d-flex flex-wrap'>

                          <div className="card w-100 " >
                          <div className="card-body card-body-background p-2">
                            <h5 className="card-title">UG</h5>
                          </div>
                          <ul className="list-group list-group-flush">
                            <li className="list-group-item  p-1 fw-bold"><div className='fw-bold d-inline'>
                              BA Film Making
                            </div> <div className='fright'><i className="bi bi-clock colorred"></i>  &nbsp;3 Years  <Button className="btnlist " onClick={handleShow}>
                              Apply Now!
                            </Button></div> </li>
                          </ul>

                        </div>
                          </div>
                        </AccordionDetails>
                      </Accordion>

                    </Hidden>
                    <div className="tab-content left-overviews-section d-none d-sm-block d-lg-block d-md-block">


                      <div className="tab-pane fade show active" id="sh1">
                        <div className="card " >
                          <div className="card-body card-body-background p-2">
                            <h5 className="card-title">UG</h5>
                          </div>
                          <ul className="list-group list-group-flush ">
                            <li className="list-group-item  p-1 fw-bold"><div className='fw-bold d-inline'>B.Tech Computer Science & Engineering (CSE)</div> <div className='fright'><i className="bi bi-clock colorred"></i>  &nbsp;4 Years  <Button className="btnlist " onClick={handleShow}>
                              Apply Now!
                            </Button></div> </li>
                            <li className="list-group-item  p-1 fw-bold"><div className='fw-bold d-inline'>B.Tech CSE Artificial Intelligence & Machine Learning
                            </div> <div className='fright'><i className="bi bi-clock colorred"></i>  &nbsp;4 Years  <Button className="btnlist " onClick={handleShow}>
                              Apply Now!
                            </Button></div> </li>
                            <li className="list-group-item  p-1 fw-bold"><div className='fw-bold d-inline'>B.Tech CSE Cyber Security</div> <div className='fright'><i className="bi bi-clock colorred"></i>  &nbsp;4 Years  <Button className="btnlist " onClick={handleShow}>
                              Apply Now!
                            </Button></div> </li>
                            <li className="list-group-item  p-1 fw-bold"><div className='fw-bold d-inline'>
                              B.Tech CSE Data Science
                            </div> <div className='fright'><i className="bi bi-clock colorred"></i>  &nbsp;4 Years  <Button className="btnlist " onClick={handleShow}>
                              Apply Now!
                            </Button></div> </li>
                            <li className="list-group-item  p-1 fw-bold"><div className='fw-bold d-inline'>
                              B.Tech Computer Science and Information Technology
                            </div> <div className='fright'><i className="bi bi-clock colorred"></i>  &nbsp;4 Years  <Button className="btnlist " onClick={handleShow}>
                              Apply Now!
                            </Button></div> </li>
                            <li className="list-group-item  p-1 fw-bold"><div className='fw-bold d-inline'>
                              B.Tech Electrical & Electronics Engineering (EEE)
                            </div> <div className='fright'><i className="bi bi-clock colorred"></i>  &nbsp;4 Years  <Button className="btnlist " onClick={handleShow}>
                              Apply Now!
                            </Button></div> </li>
                            <li className="list-group-item  p-1 fw-bold"><div className='fw-bold d-inline'>
                              B.Tech Electronics & Communication Engineering (ECE)
                            </div> <div className='fright'><i className="bi bi-clock colorred"></i>  &nbsp;4 Years  <Button className="btnlist " onClick={handleShow}>
                              Apply Now!
                            </Button></div> </li>
                            <li className="list-group-item  p-1 fw-bold"><div className='fw-bold d-inline'>
                              B.Tech Electronics & Instrumentation Engineering (EIE)
                            </div> <div className='fright'><i className="bi bi-clock colorred"></i>  &nbsp;4 Years  <Button className="btnlist " onClick={handleShow}>
                              Apply Now!
                            </Button></div> </li>
                            <li className="list-group-item  p-1 fw-bold"><div className='fw-bold d-inline'>
                              B.Tech Mechanical Engineering
                            </div> <div className='fright'><i className="bi bi-clock colorred"></i>  &nbsp;4 Years  <Button className="btnlist " onClick={handleShow}>
                              Apply Now!
                            </Button></div> </li>
                            <li className="list-group-item  p-1 fw-bold"><div className='fw-bold d-inline'>
                              B.Tech Civil Engineering
                            </div> <div className='fright'><i className="bi bi-clock colorred"></i>  &nbsp;4 Years  <Button className="btnlist " onClick={handleShow}>
                              Apply Now!
                            </Button></div> </li>
                            <li className="list-group-item  p-1 fw-bold"><div className='fw-bold d-inline'>
                              BCA (Bachelor of Computer Applications)
                            </div> <div className='fright'><i className="bi bi-clock colorred"></i>  &nbsp;3 Years  <Button className="btnlist " onClick={handleShow}>
                              Apply Now!
                            </Button></div> </li>
                          </ul>

                        </div>
                        <div className="card mt-4" >
                          <div className="card-body card-body-background p-2">
                            <h5 className="card-title">PG</h5>
                          </div>
                          <ul className="list-group list-group-flush">
                            <li className="list-group-item  p-1 fw-bold"><div className='fw-bold d-inline'>
                              M.Tech Construction Technology & Management
                            </div> <div className='fright'><i className="bi bi-clock colorred"></i>  &nbsp;2 Years  <Button className="btnlist " onClick={handleShow}>
                              Apply Now!
                            </Button></div> </li>
                            <li className="list-group-item  p-1 fw-bold"><div className='fw-bold d-inline'>
                              M.Tech Electrical Power Systems
                            </div> <div className='fright'><i className="bi bi-clock colorred"></i>  &nbsp;2 Years  <Button className="btnlist " onClick={handleShow}>
                              Apply Now!
                            </Button></div> </li>
                            <li className="list-group-item  p-1 fw-bold"><div className='fw-bold d-inline'>
                              M.Tech Machine Design
                            </div> <div className='fright'><i className="bi bi-clock colorred"></i>  &nbsp;2 Years  <Button className="btnlist " onClick={handleShow}>
                              Apply Now!
                            </Button></div> </li>


                            <li className="list-group-item  p-1 fw-bold"><div className='fw-bold d-inline'>
                              M.Tech VLSI & Embedded System Design
                            </div> <div className='fright'><i className="bi bi-clock colorred"></i>  &nbsp;2 Years  <Button className="btnlist " onClick={handleShow}>
                              Apply Now!
                            </Button></div> </li>
                            <li className="list-group-item  p-1 fw-bold"><div className='fw-bold d-inline'>
                              MCA (Master of Computer Applications)
                            </div> <div className='fright'><i className="bi bi-clock colorred"></i>  &nbsp;2 Years  <Button className="btnlist " onClick={handleShow}>
                              Apply Now!
                            </Button></div> </li>





                          </ul>

                        </div>


                      </div>
                      <div className="tab-pane fade" id="sh2">
                        <div className="card " >
                          <div className="card-body card-body-background p-2">
                            <h5 className="card-title">UG</h5>
                          </div>
                          <ul className="list-group list-group-flush">

                            <li className="list-group-item  p-1 fw-bold"><div className='fw-bold d-inline'>
                              B.Sc Bioinformatics</div> <div className='fright'><i className="bi bi-clock colorred"></i>  &nbsp;3 Years  <Button className="btnlist " onClick={handleShow}>
                                Apply Now!
                              </Button></div> </li>
                            <li className="list-group-item  p-1 fw-bold"><div className='fw-bold d-inline'>
                              B.Sc Biotechnology</div> <div className='fright'><i className="bi bi-clock colorred"></i>  &nbsp;3 Years  <Button className="btnlist " onClick={handleShow}>
                                Apply Now!
                              </Button></div> </li>
                            <li className="list-group-item  p-1 fw-bold"><div className='fw-bold d-inline'>
                              B.Sc Computer Science</div> <div className='fright'><i className="bi bi-clock colorred"></i>  &nbsp;3 Years  <Button className="btnlist " onClick={handleShow}>
                                Apply Now!
                              </Button></div> </li>
                            <li className="list-group-item  p-1 fw-bold"><div className='fw-bold d-inline'>
                              B.Sc Microbiology</div> <div className='fright'><i className="bi bi-clock colorred"></i>  &nbsp;3 Years  <Button className="btnlist " onClick={handleShow}>
                                Apply Now!
                              </Button></div> </li>

                            <li className="list-group-item  p-1 fw-bold"><div className='fw-bold d-inline'>
                              B.Sc Forensic Sciences</div> <div className='fright'><i className="bi bi-clock colorred"></i>  &nbsp;3 Years  <Button className="btnlist " onClick={handleShow}>
                                Apply Now!
                              </Button></div> </li>
                          </ul>

                        </div>
                        <div className="card mt-4" >
                          <div className="card-body card-body-background p-2">
                            <h5 className="card-title">PG</h5>
                          </div>
                          <ul className="list-group list-group-flush">

                            <li className="list-group-item  p-1 fw-bold"><div className='fw-bold d-inline'>
                              M.Sc Biotechnology
                            </div> <div className='fright'><i className="bi bi-clock colorred"></i>  &nbsp;2 Years  <Button className="btnlist " onClick={handleShow}>
                              Apply Now!
                            </Button></div> </li>
                            <li className="list-group-item  p-1 fw-bold"><div className='fw-bold d-inline'>
                              M.Sc Computer Science
                            </div> <div className='fright'><i className="bi bi-clock colorred"></i>  &nbsp;2 Years  <Button className="btnlist " onClick={handleShow}>
                              Apply Now!
                            </Button></div> </li>
                            <li className="list-group-item  p-1 fw-bold"><div className='fw-bold d-inline'>
                              M.Sc Organic Chemistry
                            </div> <div className='fright'><i className="bi bi-clock colorred"></i>  &nbsp;2 Years  <Button className="btnlist " onClick={handleShow}>
                              Apply Now!
                            </Button></div> </li>
                          </ul>

                        </div>


                      </div>
                      <div className="tab-pane fade" id="sh3">
                        <div className="card " >
                          <div className="card-body card-body-background p-2">
                            <h5 className="card-title">UG</h5>
                          </div>
                          <ul className="list-group list-group-flush">
                            <li className="list-group-item  p-1 fw-bold"><div className='fw-bold d-inline'>
                              B.Com Computer Applications</div> <div className='fright'><i className="bi bi-clock colorred"></i>  &nbsp;3 Years  <Button className="btnlist " onClick={handleShow}>
                                Apply Now!
                              </Button></div> </li>
                            <li className="list-group-item  p-1 fw-bold"><div className='fw-bold d-inline'>BBA General</div> <div className='fright'><i className="bi bi-clock colorred"></i>  &nbsp;3 Years  <Button className="btnlist " onClick={handleShow}>
                              Apply Now!
                            </Button></div> </li>
                          </ul>

                        </div>
                        <div className="card mt-4" >
                          <div className="card-body card-body-background p-2">
                            <h5 className="card-title">PG</h5>
                          </div>
                          <ul className="list-group list-group-flush">
                            <li className="list-group-item  p-1 fw-bold"><div className='fw-bold d-inline'>
                              MBA Marketing
                            </div> <div className='fright'><i className="bi bi-clock colorred"></i>  &nbsp;2 Years  <Button className="btnlist " onClick={handleShow}>
                              Apply Now!
                            </Button></div> </li>
                            <li className="list-group-item  p-1 fw-bold"><div className='fw-bold d-inline'>
                              MBA HR
                            </div> <div className='fright'><i className="bi bi-clock colorred"></i>  &nbsp;2 Years  <Button className="btnlist " onClick={handleShow}>
                              Apply Now!
                            </Button></div> </li>
                            <li className="list-group-item  p-1 fw-bold"><div className='fw-bold d-inline'>
                              MBA Finance
                            </div> <div className='fright'><i className="bi bi-clock colorred"></i>  &nbsp;2 Years  <Button className="btnlist " onClick={handleShow}>
                              Apply Now!
                            </Button></div> </li>

                          </ul>

                        </div>


                      </div>
                      <div className="tab-pane fade" id="sh4">
                        <div className="card " >
                          <div className="card-body card-body-background p-2">
                            <h5 className="card-title">UG</h5>
                          </div>
                          <ul className="list-group list-group-flush">




                            <li className="list-group-item  p-1 fw-bold"><div className='fw-bold d-inline'>
                              B.Sc Anaesthesia & Operation Theatre Technology
                            </div> <div className='fright'><i className="bi bi-clock colorred"></i>  &nbsp;3  Years  <Button className="btnlist " onClick={handleShow}>
                              Apply Now!
                            </Button></div> </li>
                            <li className="list-group-item  p-1 fw-bold"><div className='fw-bold d-inline'>
                              B.Sc Cardio Vascular Technology
                            </div> <div className='fright'><i className="bi bi-clock colorred"></i>  &nbsp;3  Years  <Button className="btnlist " onClick={handleShow}>
                              Apply Now!
                            </Button></div> </li>
                            <li className="list-group-item  p-1 fw-bold"><div className='fw-bold d-inline'>
                              B.Sc Dialysis Technology
                            </div> <div className='fright'><i className="bi bi-clock colorred"></i>  &nbsp;3  Years  <Button className="btnlist " onClick={handleShow}>
                              Apply Now!
                            </Button></div> </li>
                            <li className="list-group-item  p-1 fw-bold"><div className='fw-bold d-inline'>
                              B.Sc Emergency Medicine & Critical Care Technology
                            </div> <div className='fright'><i className="bi bi-clock colorred"></i>  &nbsp;3  Years  <Button className="btnlist " onClick={handleShow}>
                              Apply Now!
                            </Button></div> </li>
                            <li className="list-group-item  p-1 fw-bold"><div className='fw-bold d-inline'>
                              B.Sc Respiratory Therapy
                            </div> <div className='fright'><i className="bi bi-clock colorred"></i>  &nbsp;3  Years  <Button className="btnlist " onClick={handleShow}>
                              Apply Now!
                            </Button></div> </li>
                            <li className="list-group-item  p-1 fw-bold"><div className='fw-bold d-inline'>
                              B.Sc Medical Lab Technology
                            </div> <div className='fright'><i className="bi bi-clock colorred"></i>  &nbsp;3  Years  <Button className="btnlist " onClick={handleShow}>
                              Apply Now!
                            </Button></div> </li>
                            <li className="list-group-item  p-1 fw-bold"><div className='fw-bold d-inline'>
                              B.Sc Optometry
                            </div> <div className='fright'><i className="bi bi-clock colorred"></i>  &nbsp;3  Years  <Button className="btnlist " onClick={handleShow}>
                              Apply Now!
                            </Button></div> </li>
                            <li className="list-group-item  p-1 fw-bold"><div className='fw-bold d-inline'>
                              B.Sc Radiology & Imaging Technology
                            </div> <div className='fright'><i className="bi bi-clock colorred"></i>  &nbsp;3  Years  <Button className="btnlist " onClick={handleShow}>
                              Apply Now!
                            </Button></div> </li>
                            <li className="list-group-item  p-1 fw-bold"><div className='fw-bold d-inline'>
                              BPT (Bachelor of Physiotherapy)
                            </div> <div className='fright'><i className="bi bi-clock colorred"></i>  &nbsp;4  Years  <Button className="btnlist " onClick={handleShow}>
                              Apply Now!
                            </Button></div> </li>

                          </ul>

                        </div>
                        <div className="card mt-4" >
                          <div className="card-body card-body-background p-2">
                            <h5 className="card-title">PG</h5>
                          </div>
                          <ul className="list-group list-group-flush">

                            <li className="list-group-item  p-1 fw-bold"><div className='fw-bold d-inline'>
                              MPT (Physiotherapy - Neurology)
                            </div> <div className='fright'><i className="bi bi-clock colorred"></i>  &nbsp;2 Years  <Button className="btnlist " onClick={handleShow}>
                              Apply Now!
                            </Button></div> </li>
                            <li className="list-group-item  p-1 fw-bold"><div className='fw-bold d-inline'>
                              MPT (Physiotherapy - Orthopaedics)
                            </div> <div className='fright'><i className="bi bi-clock colorred"></i>  &nbsp;2 Years  <Button className="btnlist " onClick={handleShow}>
                              Apply Now!
                            </Button></div> </li>
                            <li className="list-group-item  p-1 fw-bold"><div className='fw-bold d-inline'>
                              MPT (Physiotherapy - Cardio Pulmonary)
                            </div> <div className='fright'><i className="bi bi-clock colorred"></i>  &nbsp;2 Years  <Button className="btnlist " onClick={handleShow}>
                              Apply Now!
                            </Button></div> </li>
                            <li className="list-group-item  p-1 fw-bold"><div className='fw-bold d-inline'>
                              MPT (Physiotherapy - Sports)
                            </div> <div className='fright'><i className="bi bi-clock colorred"></i>  &nbsp;2 Years  <Button className="btnlist " onClick={handleShow}>
                              Apply Now!
                            </Button></div> </li>
                          </ul>

                        </div>


                      </div>

                      <div className="tab-pane fade" id="sh5">
                        <div className="card " >
                          {/* <div className="card-body card-body-background p-2">
                            <h5 className="card-title">UG</h5>
                          </div> */}
                          <ul className="list-group list-group-flush">
                            <li className="list-group-item  p-1 fw-bold"><div className='fw-bold d-inline'>
                              School of Nursing

                            </div> <div className='fright'><Button className="btnlist " onClick={handleShow}>
                              Apply Now!
                            </Button></div> </li>
                          </ul>

                        </div>
                        {/* <div className="card mt-4" >
                          <div className="card-body card-body-background p-2">
                            <h5 className="card-title">PG</h5>
                          </div>
                          <ul className="list-group list-group-flush">

                            <li className="list-group-item  p-1 fw-bold"><div className='fw-bold d-inline'>
                              M.Com General


                            </div> <div className='fright'><i className="bi bi-clock colorred"></i>  &nbsp;2 Years  <Button className="btnlist " onClick={handleShow}>
                              Apply Now!
                            </Button></div> </li>

                            <li className="list-group-item  p-1 fw-bold"><div className='fw-bold d-inline'>
                              M.Com Forensic Audit & Corporate Fraud Management


                            </div> <div className='fright'><i className="bi bi-clock colorred"></i>  &nbsp;2 Years  <Button className="btnlist " onClick={handleShow}>
                              Apply Now!
                            </Button></div> </li>

                            <li className="list-group-item  p-1 fw-bold"><div className='fw-bold d-inline'>
                              M.Sc Digital Economics


                            </div> <div className='fright'><i className="bi bi-clock colorred"></i>  &nbsp;2 Years  <Button className="btnlist " onClick={handleShow}>
                              Apply Now!
                            </Button></div> </li>

                            <li className="list-group-item  p-1 fw-bold"><div className='fw-bold d-inline'>
                              M.Sc Biotechnology


                            </div> <div className='fright'><i className="bi bi-clock colorred"></i>  &nbsp;2 Years  <Button className="btnlist " onClick={handleShow}>
                              Apply Now!
                            </Button></div> </li>

                            <li className="list-group-item  p-1 fw-bold"><div className='fw-bold d-inline'>
                              M.Sc Computer Science


                            </div> <div className='fright'><i className="bi bi-clock colorred"></i>  &nbsp;2 Years  <Button className="btnlist " onClick={handleShow}>
                              Apply Now!
                            </Button></div> </li>

                            <li className="list-group-item  p-1 fw-bold"><div className='fw-bold d-inline'>
                              M.Sc Organic Chemistry


                            </div> <div className='fright'><i className="bi bi-clock colorred"></i>  &nbsp;2 Years  <Button className="btnlist " onClick={handleShow}>
                              Apply Now!
                            </Button></div> </li>

                            <li className="list-group-item  p-1 fw-bold"><div className='fw-bold d-inline'>
                              M.Sc Physical Education


                            </div> <div className='fright'><i className="bi bi-clock colorred"></i>  &nbsp;2 Years  <Button className="btnlist " onClick={handleShow}>
                              Apply Now!
                            </Button></div> </li>
                            <li className="list-group-item  p-1 fw-bold"><div className='fw-bold d-inline'>
                              M.Sc Data Science & Analytics


                            </div> <div className='fright'><i className="bi bi-clock colorred"></i>  &nbsp;2 Years  <Button className="btnlist " onClick={handleShow}>
                              Apply Now!
                            </Button></div> </li>
                            <li className="list-group-item  p-1 fw-bold"><div className='fw-bold d-inline'>
                              MA English


                            </div> <div className='fright'><i className="bi bi-clock colorred"></i>  &nbsp;2 Years  <Button className="btnlist " onClick={handleShow}>
                              Apply Now!
                            </Button></div> </li>





                          </ul>

                        </div> */}


                      </div>
                      <div className="tab-pane fade" id="sh6">

                        <div className="card " >
                          <div className="card-body card-body-background p-2">
                            <h5 className="card-title">UG</h5>
                          </div>
                          <ul className="list-group list-group-flush">
                            <li className="list-group-item  p-1 fw-bold"><div className='fw-bold d-inline'>
                              B.Pharmacy

                            </div> <div className='fright'><i className="bi bi-clock colorred"></i>  &nbsp;4 Years  <Button className="btnlist " onClick={handleShow}>
                              Apply Now!
                            </Button></div> </li>
                          </ul>

                        </div>

                        <div className="card mt-4" >
                          <div className="card-body card-body-background p-2">
                            <h5 className="card-title">PG</h5>
                          </div>
                          <ul className="list-group list-group-flush">

                            <li className="list-group-item  p-1 fw-bold"><div className='fw-bold d-inline'>
                              M.Pharmacy (Pharmaceutics)
                            </div> <div className='fright'><i className="bi bi-clock colorred"></i>  &nbsp;2 Years  <Button className="btnlist " onClick={handleShow}>
                              Apply Now!
                            </Button></div> </li>
                            <li className="list-group-item  p-1 fw-bold"><div className='fw-bold d-inline'>
                              M.Pharmacy (Pharmaceutical Analysis)
                            </div> <div className='fright'><i className="bi bi-clock colorred"></i>  &nbsp;2 Years  <Button className="btnlist " onClick={handleShow}>
                              Apply Now!
                            </Button></div> </li>
                            <li className="list-group-item  p-1 fw-bold"><div className='fw-bold d-inline'>
                              Pharm.D
                            </div> <div className='fright'><i className="bi bi-clock colorred"></i>  &nbsp;6 Years  <Button className="btnlist " onClick={handleShow}>
                              Apply Now!
                            </Button></div> </li>
                            <li className="list-group-item  p-1 fw-bold"><div className='fw-bold d-inline'>
                              Pharm.D (Post Baccalaureate)
                            </div> <div className='fright'><i className="bi bi-clock colorred"></i>  &nbsp;3 Years  <Button className="btnlist " onClick={handleShow}>
                              Apply Now!
                            </Button></div> </li>
                          </ul>

                        </div>

                      </div>
                      <div className="tab-pane fade" id="sh7">

                        <div className="card " >
                          <div className="card-body card-body-background p-2">
                            <h5 className="card-title">UG</h5>
                          </div>
                          <ul className="list-group list-group-flush">



                            <li className="list-group-item  p-1 fw-bold"><div className='fw-bold d-inline'>
                              B.Sc (Hons.) Agriculture
                            </div> <div className='fright'><i className="bi bi-clock colorred"></i>  &nbsp;4 Years  <Button className="btnlist " onClick={handleShow}>
                              Apply Now!
                            </Button></div> </li>
                          </ul>

                        </div>

                      </div>
                      <div className="tab-pane fade" id="sh8">
                        <div className="card " >
                          <div className="card-body card-body-background p-2">
                            <h5 className="card-title">UG</h5>
                          </div>
                          <ul className="list-group list-group-flush">
                            <li className="list-group-item  p-1 fw-bold"><div className='fw-bold d-inline'>
                              BA Film Making
                            </div> <div className='fright'><i className="bi bi-clock colorred"></i>  &nbsp;3 Years  <Button className="btnlist " onClick={handleShow}>
                              Apply Now!
                            </Button></div> </li>
                          </ul>
                         

                        </div>
                       
                      </div>

                    

                     
                    </div>

                  </div>
                </div>
              </div>
            </div>

          </div>
        </div >

      </section >

      <section className="container-fluid pb-0 pt-3" id ="infrastructure" >
        <div className="container">
          <div className="row">
            <div className="col-lg-12 text-center pt-3">
              <h3 className='fh3mohan'>Mohan Babu University, Tirupati Campus Infrastructure</h3>
            </div>

            <div className="col-lg-12 text-center pt-3 pb-3"><p>The Mohan Babu University, Tirupati campus is designed with the intent to impart quality education. Dedicated academic blocks, spacious classrooms, well-stocked central library, incubation centres, training and placement centre, open courtyards and landscaping, are some of the key features of MBU Tirupati infrastructure and facilities.</p></div>
          </div>
          <div className="col-lg-12 text-center">
            <div className="row row-cols-1 row-cols-md-3 g-4">


              <div className="col">
                <div className="card portflio-item position-relative">
                  <img src={inf1} className="card-img-top " alt="inf6" />
                  <div className="portfolio-item-content">
                    <h3 className="mb-0 text-white link">Entrance</h3>
                  </div>
                </div>
              </div>
              <div className="col">
                <div className="card portflio-item position-relative">
                  <img src={inf2} className="card-img-top " alt="inf6" />
                  <div className="portfolio-item-content">
                    <h3 className="mb-0 text-white link">Academic Blocks</h3>
                  </div>
                </div>
              </div>
              <div className="col">
                <div className="card portflio-item position-relative">
                  <img src={inf3} className="card-img-top " alt="inf6" />
                  <div className="portfolio-item-content">
                    <h3 className="mb-0 text-white link">Laboratories</h3>
                  </div>
                </div>
              </div>
              <div className="col">
                <div className="card portflio-item position-relative">
                  <img src={inf4} className="card-img-top " alt="inf6" />
                  <div className="portfolio-item-content">
                    <h3 className="mb-0 text-white link">Playgrounds</h3>
                  </div>
                </div>
              </div>
              <div className="col">
                <div className="card portflio-item position-relative">
                  <img src={inf5} className="card-img-top " alt="inf6" />
                  <div className="portfolio-item-content">
                    <h3 className="mb-0 text-white link">Central Library</h3>
                  </div>
                </div>
              </div>
              <div className="col">
                <div className="card portflio-item position-relative">
                  <img src={inf6} className="card-img-top " alt="inf6" />
                  <div className="portfolio-item-content">
                    <h3 className="mb-0 text-white link">Extracurriculars</h3>
                  </div>
                </div>
              </div>

              <span id ="whychoose" style={{ display: "hidden" }}></span>
            </div>
          </div>


        </div>
      </section>

      <section className="container-fluid pb-0">
        <div className="container">
          <div className="row pt-3 pt-md-0">
            <div className="col-lg-12 text-center">
              <h3 className='fh3mohan'>Why Choose Mohan Babu University, Tirupati</h3>
            </div>
            <div className="col-lg-12 text-center pt-3 pb-3"><p>MBU University, Tirupati, is one of those educational institutions that truly care for the well-being and growth of each of its students. Here are some reasons why MBU Tirupati might be the best choice for you!</p></div>
          </div>
        </div>
        <div className="container">
          <div className="row  pt-md-0"></div>


          <div className="col-lg-12 text-center">
            <div className="row  gutter" >
              <div className="col-lg-4 col-md-4">
                <div className="featured-item style-4">
                  <img src={whychhose1} className="card-img-top " alt="inf6" />
                  <div className="featured-title">
                    <h5 style={{ fontWeight: 700 }}>
                      30 Years of Academic Excellence
                    </h5>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-4">
                <div className="featured-item style-4">
                  <img src={whychhose2} className="card-img-top " alt="inf6" />
                  <div className="featured-title">
                    <h5 style={{ fontWeight: 700 }}>
                      Accredited by NAAC & NBA
                    </h5>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-4">
                <div className="featured-item style-4">
                  <img src={whychhose3} className="card-img-top " alt="inf6" />
                  <div className="featured-title">
                    <h5 style={{ fontWeight: 700 }}>

                      Recognized by ARIIA & AICTE
                    </h5>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-4">
                <div className="featured-item style-4">
                  <img src={whychhose4} className="card-img-top " alt="inf6" />
                  <div className="featured-title">
                    <h5 style={{ fontWeight: 700 }}>

                      State-of-the-art
                      <span className='d-block'>Educational Facilities</span>
                    </h5>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-4">
                <div className="featured-item style-4">
                  <img src={whychhose5} className="card-img-top " alt="inf6" />
                  <div className="featured-title">
                    <h5 style={{ fontWeight: 700 }}>
                      Excellent Placement Record
                    </h5>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-4" >
                <div className="featured-item style-4">
                  <img src={whychhose6} className="card-img-top " alt="inf6"  />
                  <span id ="placements" style={{ display: "hidden" }}></span>

                  <div className="featured-title"  >
                    <h5 style={{ fontWeight: 700 }} >
                      Cohesive Platform for Startups
                    </h5>
                  </div>
                </div>
              </div>
            </div>



          </div>


        </div>
      </section>
      <section className="container-fluid pb-0"  >
        <div className="container">
          <div className="row pt-3 pt-md-0">
            <div className="col-lg-12 text-center">
              <h3 className='fh3mohan'>Mohan Babu University Placements</h3>
            </div>
            <div className="col-lg-12 text-center pt-3 pb-3"><p>With each year, the Mohan Babu University Placements have shown a positive trend in all respects. MBU has a Training and Placement Centre that formulates a comprehensive Recruitment Training Program for every year based on the current industry trends in the respective fields. Mohan Babu University has come up with unique ways of encouraging and inspiring students to excel through its schemes such as the ‘Dream Offer’ and ‘Super Dream Offer’.</p></div>

            <div className="col-lg-12 text-center pt-3 pb-3">
              <div className="row row-cols-1 row-cols-md-2 g-3">
                <div className='col'>

                  <div className="card position-relative border-0 ">
                    <img className="card-img-top" src={placement2} alt="Skill Development" />
                    {/* <div className="card-body card-body-background">
                      <h5 className="card-title">Highest Package</h5>
                      <h5 className="card-title">60 LPA</h5>
                    </div> */}
                  </div></div>
                <div className='col'>
                  <div className="card position-relative border-0 ">
                    <img className="card-img-top" src={placement1} alt="Value Orientation" />
                    {/* <div className="card-body card-body-background">
                      <h5 className="card-title">Average Package</h5>
                      <h5 className="card-title">6 LPA</h5>

                    </div> */}
                  </div>
                </div>





              </div>

            </div>
            <div className="col-lg-12 text-center pt-3 pb-3">
              <h3 className='fh3mohan'>Training and Placement Activities</h3>

              <div className='row m90  text-left  paddingleft'>
                <div className="col-md-6 col-12 " >
                  <ul>
                    <li>Career Counselling & Guidance</li>
                    <li>Lectures & Workshops with Domain Experts</li>
                    <li>Industrial Visits & In-Plant Training</li>
                    <li>‘Dream Offer’ & ‘Super Dream Offer’</li>
                  </ul>

                </div>
                <div className="col-md-6 col-12" >
                  <ul>
                    <li>Mock Campus Interview by Professional Trainers</li>
                    <li>Interactive Sessions with Recently Placed Alumni</li>
                    <li>Aptitude, GD & Campus Interview Training</li>
                    <li>Project-based Learning & Internships</li>
                  </ul>
                </div>
              </div>





              <p className="pt-3 pb-3">MBU Tirupati goes above and beyond through its Placement Consortium that collaborates with other colleges and helps them with their placement and training activities.</p>

            </div>

          </div>
        </div>

      </section>


      <section className="container-fluid  pb-0" id="recruiters">
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-12 text-center">
              <h3 className='fh3mohan'>Top Recruiters
              </h3>


              <OwlCarousel {...owlOptions} className="topTrendingCourses loop_nav owl-carousel owl-theme ">



                <div className="item">

                  <img src={Logo1} className="customimage" alt="accredation1" />
                </div>

                <div className="item">

                  <img src={Logo2} className="customimage" alt="accredation1" />
                </div>
                <div className="item">

                  <img src={Logo3} className="customimage" alt="accredation1" />
                </div>
                <div className="item">

                  <img src={Logo4} className="customimage" alt="accredation1" />
                </div>
                <div className="item">

                  <img src={Logo5} className="customimage" alt="accredation1" />
                </div>
                <div className="item">

                  <img src={Logo6} className="customimage" alt="accredation1" />
                </div>
                <div className="item">

                  <img src={Logo7} className="customimage" alt="accredation1" />
                </div>
                <div className="item">

                  <img src={Logo8} className="customimage" alt="accredation1" />
                </div>
                <div className="item">

                  <img src={Logo9} className="customimage" alt="accredation1" />
                </div>
                <div className="item">

                  <img src={Logo10} className="customimage" alt="accredation1" />
                </div>
                <div className="item">

                  <img src={Logo11} className="customimage" alt="accredation1" />
                </div>
                <div className="item">

                  <img src={Logo12} className="customimage" alt="accredation1" />
                </div>
                <div className="item">

                  <img src={Logo13} className="customimage" alt="accredation1" />
                </div>
                <div className="item">

                  <img src={Logo14} className="customimage" alt="accredation1"  />
                </div>
                <div className="item">

                  <img src={Logo15} className="customimage" alt="accredation1" id ="FAQs"  />
                </div>  
              </OwlCarousel>
             

            </div>
           
          </div>

        </div >

      </section >

      <div className="faq-section p-3 bg-gray-2" >
        <div className="container ">
          <div className="faq-header ">
            <h2
              style={{
                color: "#1D3355",
                fontWeight: 600,
                textAlign: "center",
                paddingTop: 10
              }}
            >
              FAQs
            </h2>
          </div>
          <div className="faq-outer ">
            <div className="faq-img ">
              <img src="preprod/nursing_admission/assets/images/faq-img.png" alt="FAQs " />
            </div>
            <div
              className="faq-sec "
              style={{
                background:
                  "linear-gradient(90deg,transparent, #ebebfb, transparent)"
              }}
            >
              {/* <div class=""> */}
              {/* <div class="faq-img">
                      <img src="preprod/nursing_admission/assets/images/faq.jpg "
                      alt="Helping hand in the College application process " width="100%"> 
                  </div>*/}
              <div className="">
                <div className="Accordions ">
                  <div className="Accordion_item ">
                    <div className="title_tab ">
                      <h3 className="title ">
                        Where is the Mohan Babu University (MBU) located?
                        <span className="icon ">
                          <svg
                            xmlns="http://www.w3.org/2000/svg "
                            width={16}
                            height={16}
                            fill="currentColor "
                            className="bi bi-chevron-down "
                            viewBox="0 0 16 16 "
                          >
                            <path
                              // fillRule="evenodd "
                              d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z "
                            />
                          </svg>
                        </span>
                      </h3>
                    </div>
                    <div className="inner_content ">
                      <p>
                        Mohan Babu University (MBU) is located in Tirupati in Andhra Pradesh.
                      </p>
                    </div>
                  </div>
                  <div className="Accordion_item ">
                    <div className="title_tab ">
                      <h3 className="title ">
                        When was the Mohan Babu University (MBU) established?
                        <span className="icon ">
                          <svg
                            xmlns="http://www.w3.org/2000/svg "
                            width={16}
                            height={16}
                            fill="currentColor "
                            className="bi bi-chevron-down "
                            viewBox="0 0 16 16 "
                          >
                            <path
                              // fillRule="evenodd "
                              d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z "
                            />
                          </svg>
                        </span>
                      </h3>
                    </div>
                    <div className="inner_content ">
                      <p>
                        Sree Vidyanikethan Educational Institutions started in 1992 became the Mohan Babu University in 2022.
                      </p>
                    </div>
                  </div>
                  <div className="Accordion_item ">
                    <div className="title_tab ">
                      <h3 className="title ">
                        What are the Mohan Babu University courses offered?
                        <span className="icon ">
                          <svg
                            xmlns="http://www.w3.org/2000/svg "
                            width={16}
                            height={16}
                            fill="currentColor "
                            className="bi bi-chevron-down "
                            viewBox="0 0 16 16 "
                          >
                            <path
                              // fillRule="evenodd "
                              d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z "
                            />
                          </svg>
                        </span>
                      </h3>
                    </div>
                    <div className="inner_content ">
                      <p>
                        Mohan Babu University, Tirupati, has 9 schools offering UG and PG programmes in streams such as Engineering, Commerce, Management, Paramedical Sciences, Liberal Arts, Sciences, Art and Design, Agriculture, and Media Studies.

                      </p>
                    </div>
                  </div>
                  <div className="Accordion_item ">
                    <div className="title_tab ">
                      <h3 className="title ">
                        How do Mohan Babu University admissions happen?
                        <span className="icon ">
                          <svg
                            xmlns="http://www.w3.org/2000/svg "
                            width={16}
                            height={16}
                            fill="currentColor "
                            className="bi bi-chevron-down "
                            viewBox="0 0 16 16 "
                          >
                            <path
                              // fillRule="evenodd "
                              d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z "
                            />
                          </svg>
                        </span>
                      </h3>
                    </div>
                    <div className="inner_content ">
                      <p>
                        Mohan Babu University admissions are based on marks secured in qualifying exams and other relevant entrance exams. Every year the Mohan Babu University, Tirupati cut-off varies.
                      </p>
                    </div>
                  </div>
                  <div className="Accordion_item ">
                    <div className="title_tab ">
                      <h3 className="title ">
                        How is the Mohan Babu University, Tirupati campus?
                        <span className="icon ">
                          <svg
                            xmlns="http://www.w3.org/2000/svg "
                            width={16}
                            height={16}
                            fill="currentColor "
                            className="bi bi-chevron-down "
                            viewBox="0 0 16 16 "
                          >
                            <path
                              // fillRule="evenodd "
                              d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z "
                            />
                          </svg>
                        </span>
                      </h3>
                    </div>
                    <div className="inner_content ">
                      <p>
                        MBU Tirupati provides a vibrant campus that facilitates overall development of its students. Academic blocks, spacious classrooms, central library, incubation centres, training and placement centre are some of the key features of MBU Tirupati infrastructure and facilities.

                      </p>
                    </div>
                  </div>
                  <div className="Accordion_item ">
                    <div className="title_tab ">
                      <h3 className="title ">
                        How are the Mohan Babu University placements?

                        <span className="icon ">
                          <svg
                            xmlns="http://www.w3.org/2000/svg "
                            width={16}
                            height={16}
                            fill="currentColor "
                            className="bi bi-chevron-down "
                            viewBox="0 0 16 16 "
                          >
                            <path
                              // fillRule="evenodd "
                              d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z "
                            />
                          </svg>
                        </span>
                      </h3>
                    </div>
                    <div className="inner_content ">
                      <p>
                        MBU University, Tirupati, has an excellent placement record with students being placed with some of the highest packages offered in the job market (such as 60 LPA and 37 LPA).
                      </p>
                    </div>
                  </div>
                  <div className="Accordion_item ">
                    <div className="title_tab ">
                      <h3 className="title ">
                        What is the Mohan Babu University NIRF ranking?

                        <span className="icon ">
                          <svg
                            xmlns="http://www.w3.org/2000/svg "
                            width={16}
                            height={16}
                            fill="currentColor "
                            className="bi bi-chevron-down "
                            viewBox="0 0 16 16 "
                          >
                            <path
                              // fillRule="evenodd "
                              d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z "
                            />
                          </svg>
                        </span>
                      </h3>
                    </div>
                    <div className="inner_content ">
                      <p>
                        Mohan Babu University, Tirupati, has secured 165th position in the NIRF rankings.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* </div> */}
          </div>
        </div>
      </div>
      <section className="container-fluid d-flex align-items-center pb-3 " id="Contact">
        <div className="container bgimage text-center d-flex justify-content-center align-items imgh" id="home" style={{ background: `linear-gradient(341deg, rgb(0 0 0 / 0%), rgb(0 0 0 / 0%)) , url(${banner})` }}>
          <div className='dd'><h2 className='bgblack  p-3'>Choose MBU, <span className='d-block d-md-inline'>Choose Excellence.</span></h2>
            <Button className="button mb-4 m-3 m-md-5 " onClick={handleShow}>
              Apply Now!
            </Button>
          </div>
        </div>


      </section>
      <footer id="contact" className='back-footer pt-0  pb-0' >
        <div className="footer-top p-0">
          <div className="container-fluid ">
            <div className="row p-md-5 pb-md-3" style={{ justifyContent: "space-between" }}>
              <div className="col-lg-6 col-md-6 footer-contact ps-4 ps-md-5">
                <img src={logo} alt="logo" className="img-responsive ps-0 ps-md-5" />
              </div>

              <div
                className="col-lg-6 col-md-6 footer-newsletter text-black d-flex justify-content-md-end"

              >
                <div className='pt-5  pt-md-2 pe-0 pe-md-5 text-white ps-0 ps-md-5'>
                  <h4 className='contactred font20'>Mohan Babu University Address:</h4>
                  <p className='pt-3'>
                    <i className="fa fa-home contacticon yellew"></i>&nbsp; Sree Sainath Nagar,
                    <br />
                    Tirupati, Chittoor District
                    <br />
                    Andhra Pradesh - 517102
                  </p>
                  <p className='pt-3'><i className="fa fa-envelope-o contacticon yellew"></i>&nbsp;  mohanbabuuniversity56@gmail.com
                  </p>
                  <p className='pt-3'> <i className="fa fa-phone  contacticon yellew"></i>&nbsp;  9036020016
                  </p>
                </div>
              </div>
            </div>
            <div className="text-center pt-4 pt-md-0 pb-3">Copyright @ Bangalore Study 2025</div>
          </div>
        </div>

      </footer>
      <a
        href="https://wa.me/+919036020016"
        style={{
          position: "fixed",
          width: 63,
          height: 64,
          bottom: 7,
          right: 24,
          // backgroundColor: "#25d366",
          color: "#fff",
          borderRadius: 50,
          textAlign: "center",
          fontSize: 44,
          boxShadow: "2px 2px 3px #999",
          zIndex: 1059
        }}
        target="_blank "
      >
        {/* <i className="bi bi-whatsapp my-float " /> */}
                <img src={whtsp} alt='whtsplogo' style={{ width: "66px" }}></img>
        
      </a>

      <Modal show={show} onHide={handleClose}>

        <Modal.Body>

          <div className="heading-popup pb-5">
            <h4 className='text-center'>{text}</h4>
          </div>
          <EnquiryForm />

        </Modal.Body>

      </Modal>

    </>
  );
};

export default Mohanbabu;